export type ProductCategory = 'Bondex Sünger' | 'Bariyerli Bondex' | 'Çift Bariyerli Bondex' | 'Akustik Sünger';

export type FAQ = {
  question: string;
  answer: string;
};

export type ProductReview = {
  authorName: string;
  datePublished: string; // YYYY-MM-DD
  ratingValue: number; // 1-5
  title: string;
  body: string;
  verified?: boolean;
};

export type Product = {
  slug: string; // path without leading slash
  name: string;
  category: ProductCategory;
  thicknessMm?: number;
  shortDescription: string;
  description: string;
  imagePath: string; // served from /images
  imageGallery?: string[]; // optional gallery images
  sku: string;
  mpn: string;
  priceTRY?: number; // price per m² (optional; WhatsApp-based ordering)
  priceUnit?: 'm2' | 'plaka' | 'adet'; // fiyat birimi
  faqs?: FAQ[];
  reviews?: ProductReview[];
};

export const products: Product[] = [
  {
    slug: 'bondex-sunger',
    name: 'Bondex Sünger',
    category: 'Bondex Sünger',
    shortDescription:
      'Yüksek yoğunluklu rebonded süngerpan: ses yalıtımı ve darbe sönümleme için güvenilir çözüm.',
    description:
      'Bondex sünger; rebonded süngerpan (süngerpan) formunda, yüksek yoğunluklu yapısıyla ses yalıtımı ve titreşim sönümleme uygulamalarında tercih edilen bir malzemedir. Stüdyo, jeneratör odası, makine dairesi ve kapı/duvar detaylarında pratik, performans odaklı bir çözümdür.',
    imagePath: '/images/bondex.webp',
    imageGallery: [
      '/images/bondex.webp',
      '/images/bondex-2.webp',
      '/images/bondex-3.webp',
      '/images/bondex-4.webp',
      '/images/bondex-5.webp',
      '/images/bondex-6.webp',
      '/images/bondex-7.webp',
      '/images/bondex-8.webp',
      '/images/bondex-9.webp',
    ],
    sku: 'BDX-BASE',
    mpn: 'BDX-BASE',
    priceTRY: 110, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bondex sünger nedir?',
        answer:
          'Bondex sünger; rebonded süngerpan olarak da bilinen, parçacık süngerlerin preslenmesiyle üretilen yüksek yoğunluklu bir sünger türüdür.',
      },
      {
        question: 'Bondex sünger nerelerde kullanılır?',
        answer:
          'Ses yalıtımı, darbe sönümleme, titreşim azaltma ve zemin/duvar detaylarında destek malzemesi olarak kullanılır.',
      },
      {
        question: 'Bondex sünger ses yalıtımı yapar mı?',
        answer:
          'Bondex sünger; tek başına uygulandığında ses ve titreşim etkisini azaltmaya yardımcı olur. En iyi sonuç, doğru kalınlık seçimi ve uygulama detayları (yapıştırma, katman kurgusu, gerekiyorsa bariyer) ile alınır.',
      },
      {
        question: 'Bondex sünger kaç mm olmalı?',
        answer:
          'Doğru kalınlık; hedef izolasyon seviyesi, uygulama yüzeyi ve gürültü tipine göre değişir. İnce detaylar için 10–20mm, daha yüksek sönümleme için 30–50mm gibi seçenekler proje ihtiyacına göre değerlendirilir.',
      },
      {
        question: 'Bondex sünger mi, Bariyerli Bondex mi?',
        answer:
          'Klasik uygulamalarda Bondex sünger yeterli olabilir. Daha yüksek izolasyon hedeflerinde ise bariyer katmanı ile güçlendirilmiş Bariyerli Bondex sistemleri tercih edilir. Proje şartlarına göre birlikte de kullanılabilir.',
      },
      {
        question: 'Bondex sünger yapıştırılır mı, nasıl uygulanır?',
        answer:
          'Bondex sünger uygulaması yüzeye ve projeye göre değişir; çoğu senaryoda uygun yapıştırıcı ile yüzeye sabitlenir. Kesim/ek yerleri ve katman geçişleri performansı etkilediği için proje bazlı uygulama önerilir.',
      },
      {
        question: 'Bondex sünger fiyatı ne kadar?',
        answer:
          'Bondex sünger fiyatı metrekare (m²) başına 130 TL\'dir. Fiyatlar metraj, plaka ölçüsü ve proje adedine göre değişir. 10mm, 20mm, 30mm, 40mm, 50mm kalınlık seçenekleri mevcuttur. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
    ],
    reviews: [
      {
        authorName: 'Ahmet Yılmaz',
        datePublished: '2025-09-06',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Bondex sünger satın aldım, çok memnunum. Ses yalıtımı gerçekten etkili. Açık ofis ortamında uygulamada farkı hemen gördük. Kesim ve sevkiyat hızlıydı.',
        verified: true,
      },
      {
        authorName: 'Mehmet Demir',
        datePublished: '2025-09-23',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Mükemmel bir ürün. Titreşim sönümleme performansı beklediğimden daha iyi. Uygulama kolay ve iletişim çok hızlıydı.',
        verified: true,
      },
      {
        authorName: 'Ayşe Kaya',
        datePublished: '2025-10-06',
        ratingValue: 4,
        title: 'Çok iyi',
        body:
          'Bondex sünger ihtiyacımızı karşıladı. Ses yalıtımı iyi, daha kalın bir modelle daha yüksek performans alınabilir. Genel olarak memnunuz.',
        verified: true,
      },
      {
        authorName: 'Can Özkan',
        datePublished: '2025-10-13',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Ekipman odasında kullandık. Gürültü seviyesi belirgin şekilde azaldı. Malzeme kalitesi iyi, teslimat sorunsuz.',
        verified: true,
      },
      {
        authorName: 'Zeynep Arslan',
        datePublished: '2025-10-20',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Stüdyo uygulamasında kullandık. Ses yalıtımı mükemmel. Ürün kalitesi ve müşteri hizmetleri çok iyi. Kesinlikle tavsiye ederim.',
        verified: true,
      },
      {
        authorName: 'Fatma Şahin',
        datePublished: '2025-11-05',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Uygulama çok hızlıydı. Ürün kalitesi beklentimizi aştı. Dışarıdan gelen sesler ciddi şekilde azaldı.',
        verified: true,
      },
      {
        authorName: 'Burak Şahin',
        datePublished: '2025-11-02',
        ratingValue: 4,
        title: 'Çok iyi',
        body:
          'Fiyat/performans açısından iyi. Tasarım gerektirmeden pratik uygulandı. Bir tık daha kalın seçsek daha da iyi olurdu.',
        verified: true,
      },
    ],
  },
  {
    slug: 'sungerpan',
    name: 'Süngerpan ve Rebonded Sünger',
    category: 'Bondex Sünger',
    thicknessMm: 10,
    shortDescription:
      'Echopan Süngerpan yüksek yoğunluklu rebonded yapısıyla duvar tavan ve zemin uygulamalarında ses geçişini azaltmaya yardımcı olur. Projeye göre doğru kalınlık ve yoğunlukla etkili yalıtım sağlar.',
    description:
      'Süngerpan, yüksek yoğunluklu rebonded yapısıyla darbe ve hava kaynaklı seslerin kontrol altına alınmasına yardımcı olan profesyonel bir ses yalıtım malzemesidir. Echopan olarak duvar, tavan ve zemin gibi farklı uygulama alanlarında proje odaklı süngerpan çözümleri sunuyoruz.',
    imagePath: '/images/bondex.webp',
    imageGallery: [
      '/images/bondex.webp',
      '/images/bondex-2.webp',
      '/images/bondex-3.webp',
      '/images/bondex-4.webp',
      '/images/bondex-5.webp',
      '/images/bondex-6.webp',
      '/images/bondex-7.webp',
      '/images/bondex-8.webp',
      '/images/bondex-9.webp',
    ],
    sku: 'SGP-BASE',
    mpn: 'SGP-BASE',
    priceTRY: 110,
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Süngerpan nedir?',
        answer:
          'Süngerpan, poliüretan kırpıntıların yüksek basınçla sıkıştırılmasıyla üretilen yüksek yoğunluklu rebonded sünger malzemesidir. Ses yalıtımı ve titreşim sönümleme uygulamalarında kullanılır.',
      },
      {
        question: 'Süngerpan ses yalıtımı sağlar mı?',
        answer:
          'Süngerpan, doğru sistem içinde kullanıldığında ses geçişini azaltmaya yardımcı olur. Darbe ve titreşim kaynaklı seslerde güçlü katkı sağlar. Hava yolu seslerinde bariyer ve doğru katman kurgusuyla daha yüksek performans alınır.',
      },
      {
        question: 'Rebonded sünger nerelerde kullanılır?',
        answer:
          'Rebonded sünger ofis, toplantı odası, stüdyo, çağrı merkezi, makine dairesi ve ev sinema odası gibi alanlarda duvar, tavan ve zemin katmanlarında kullanılır.',
      },
      {
        question: 'Süngerpan ile akustik sünger aynı ürün mü?',
        answer:
          'Hayır. Süngerpan yüksek yoğunluklu yalıtım katmanıdır. Akustik sünger ise oda içi yankı kontrolünde kullanılan yüzey emici üründür. İki ürün farklı görev görür ve birlikte kullanılabilir.',
      },
      {
        question: 'Süngerpan fiyatı nasıl belirlenir?',
        answer:
          'Süngerpan fiyatı kalınlık, yoğunluk, metraj ve teslimat detayına göre belirlenir. Güncel m² fiyatı ve proje teklifi için Echopan ile iletişime geçebilirsiniz.',
      },
      {
        question: 'Süngerpan montajı nasıl yapılır?',
        answer:
          'Yüzey hazırlığı sonrası yapıştırma veya karkas içine yerleştirme yöntemi uygulanır. Ek yerlerinin boşluksuz kapatılması performans için kritik önemdedir.',
      },
    ],
    reviews: [
      {
        authorName: 'Mert Karaca',
        datePublished: '2026-01-09',
        ratingValue: 5,
        title: 'Duvar uygulamasında fark net',
        body:
          'Ortak duvarda süngerpan uyguladık. Konuşma sesi tamamen bitmedi ama rahatsızlık ciddi şekilde azaldı. Malzeme yoğunluğu ve kesim kalitesi gayet iyi.',
        verified: true,
      },
      {
        authorName: 'Ece Demir',
        datePublished: '2026-01-18',
        ratingValue: 5,
        title: 'Ofis bölmesinde başarılı',
        body:
          'Toplantı odası bölmesinde kullandık. Dışarıya ses taşması belirgin şekilde düştü. Montaj sonrası ortam daha kontrollü hale geldi.',
        verified: true,
      },
      {
        authorName: 'Hakan Özer',
        datePublished: '2026-01-27',
        ratingValue: 4,
        title: 'Fiyat performans iyi',
        body:
          '20 mm yerine bu ürünü teknik yönlendirme ile aldık. Doğru yoğunluk seçimiyle beklediğimiz performansı aldık. Teklif ve sevkiyat süreci hızlı ilerledi.',
        verified: true,
      },
      {
        authorName: 'Selin Acar',
        datePublished: '2026-02-04',
        ratingValue: 5,
        title: 'Ev sinema odası için iyi seçim',
        body:
          'Bas seslerde dışarıya kaçış azaldı. Üstüne akustik kaplama ile birlikte daha dengeli sonuç aldık. Ürün anlatıldığı gibi çıktı.',
        verified: true,
      },
      {
        authorName: 'Burak Tuncel',
        datePublished: '2026-02-12',
        ratingValue: 5,
        title: 'Zemin altında ezilme yapmadı',
        body:
          'Şap altı uygulamada kullandık. Yoğunluk iyi olduğu için kısa sürede çökme yaşamadık. Darbe sesinde fark hissediliyor.',
        verified: false,
      },
      {
        authorName: 'Ayşe Çetin',
        datePublished: '2026-02-21',
        ratingValue: 4,
        title: 'Stüdyo altyapısı için yeterli',
        body:
          'Kayıt odası altyapısında kullandık. Yalıtım katmanında işini yaptı. İç yankı için ayrıca akustik panelle tamamladık.',
        verified: true,
      },
      {
        authorName: 'Kaan Yıldırım',
        datePublished: '2026-03-03',
        ratingValue: 5,
        title: 'Makine odasında sonuç verdi',
        body:
          'Makine dairesi duvarında uygulandı. Titreşim ve uğultuda düşüş var. Doğru montajla birlikte performans tatmin edici.',
        verified: true,
      },
      {
        authorName: 'Zehra Güneş',
        datePublished: '2026-03-14',
        ratingValue: 5,
        title: 'Beklentimizi karşıladı',
        body:
          'Echopan teknik ekip doğru ürün yönlendirmesi yaptı. Süngerpan uygulamasından sonra hem konfor arttı hem ses şikayetleri azaldı.',
        verified: true,
      },
    ],
  },
  {
    slug: '150-dns-bondex-sunger',
    name: '150 DNS Bondex Sünger',
    category: 'Bondex Sünger',
    thicknessMm: 10,
    shortDescription:
      '150 DNS Bondex sünger, yüksek yoğunluklu yapısıyla titreşim ve ses kontrolü gerektiren uygulamalarda dengeli performans sunan profesyonel izolasyon çözümüdür.',
    description:
      '150 DNS Bondex sünger, yüksek yoğunluklu yapısıyla titreşim ve ses kontrolü gerektiren uygulamalar için tercih edilen profesyonel izolasyon malzemesidir.',
    imagePath: '/images/bondex-2.webp',
    imageGallery: [
      '/images/bondex-2.webp',
      '/images/bondex.webp',
      '/images/bondex-3.webp',
      '/images/bondex-4.webp',
      '/images/bondex-5.webp',
      '/images/bondex-6.webp',
      '/images/bondex-7.webp',
      '/images/bondex-8.webp',
      '/images/bondex-9.webp',
    ],
    sku: 'BDX-150DNS-10',
    mpn: 'BDX-150DNS-10',
    priceTRY: 135,
    priceUnit: 'm2',
    faqs: [
      {
        question: '150 DNS ne anlama gelir?',
        answer:
          '150 DNS değeri, bondex süngerin yoğunluk seviyesini ifade eder. Bu yoğunluk, dayanım ve sönümleme dengesini güçlü tutar.',
      },
      {
        question: '150 DNS Bondex sünger nerelerde kullanılır?',
        answer:
          'Duvar, tavan, zemin, makine dairesi, jeneratör odası ve stüdyo altyapılarında ses yalıtımı ve titreşim kontrolü için kullanılır.',
      },
      {
        question: '150 DNS Bondex sünger ses yalıtımı sağlar mı?',
        answer:
          'Doğru sistem içinde kullanıldığında ses geçişini azaltmaya yardımcı olur. Darbe ve titreşim etkilerinde güçlü katkı sağlar.',
      },
      {
        question: 'Hangi kalınlık tercih edilmelidir?',
        answer:
          'İnce detaylarda 10 mm ve 20 mm, daha yüksek performans hedeflerinde 30 mm üzeri kalınlıklar tercih edilir. Seçim proje tipine göre yapılmalıdır.',
      },
      {
        question: '150 DNS Bondex sünger yangına dayanıklı mıdır?',
        answer:
          'Yangın dayanımı ürün sınıfı ve proje şartnamesine göre değerlendirilmelidir. Uygulama öncesi teknik doküman ve sertifika kontrolü yapılmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Kerem Aydın',
        datePublished: '2026-03-01',
        ratingValue: 5,
        title: 'Duvar uygulamasında başarılı',
        body:
          '150 DNS bondex süngeri ortak duvarda kullandık. Konuşma sesinde belirgin azalma oldu. Uygulama sonrası ortam daha konforlu hale geldi.',
        verified: true,
      },
      {
        authorName: 'Seda Yılmaz',
        datePublished: '2026-03-06',
        ratingValue: 5,
        title: 'Ofiste iyi sonuç aldık',
        body:
          'Toplantı odası bölmesinde tercih ettik. Ses taşması azaldı, görüşmeler daha net oldu. Ürün yoğunluğu gayet dengeli.',
        verified: true,
      },
      {
        authorName: 'Murat Çetin',
        datePublished: '2026-03-12',
        ratingValue: 4,
        title: 'Fiyat performans iyi',
        body:
          '20 mm ile kullandık. Beklediğimiz seviyede ses kontrolü sağladı. Teknik destek hızlıydı ve doğru kalınlık yönlendirmesi yapıldı.',
        verified: true,
      },
      {
        authorName: 'Gizem Arslan',
        datePublished: '2026-03-18',
        ratingValue: 5,
        title: 'Zemin uygulamasında fark var',
        body:
          'Şap altında kullandık, darbe seslerinde düşüş net hissedildi. Malzeme ezilmeden stabil kaldı.',
        verified: false,
      },
      {
        authorName: 'Volkan Demir',
        datePublished: '2026-03-24',
        ratingValue: 5,
        title: 'Makine odasında etkili',
        body:
          'Makine dairesi duvarında uyguladık. Uğultu ve titreşimde hissedilir azalma sağladı. Ürün kalitesi tatmin edici.',
        verified: true,
      },
      {
        authorName: 'Ebru Korkmaz',
        datePublished: '2026-03-29',
        ratingValue: 4,
        title: 'Stüdyo için yeterli',
        body:
          'Prova odası altyapısında kullandık. Dışarıya ses kaçışı azaldı. İç akustik için üst katmanda panelle tamamladık.',
        verified: true,
      },
      {
        authorName: 'Burak Şen',
        datePublished: '2026-04-04',
        ratingValue: 5,
        title: 'Jeneratör odasında iyi performans',
        body:
          'Jeneratör odasında uygulama yaptık. Gürültü kontrolünde ciddi katkı sağladı. Montaj sonrası sonuçtan memnun kaldık.',
        verified: true,
      },
      {
        authorName: 'Elif Taş',
        datePublished: '2026-04-10',
        ratingValue: 5,
        title: 'Beklentimizi karşıladı',
        body:
          'Echopan ekibi doğru ürün önerdi. 150 DNS bondex sünger uygulamasından sonra hem ses şikayeti azaldı hem mekan daha sakin oldu.',
        verified: true,
      },
    ],
  },
  {
    slug: 'bondex-sunger-10mm',
    name: 'Bondex Sünger 10mm',
    category: 'Bondex Sünger',
    thicknessMm: 10,
    shortDescription:
      'Bondex sünger 10mm: ince detaylar, kaplama altı uygulamalar ve sınırlı alanlarda ses yalıtımı için ideal kalınlık. Bondex sünger fiyatları için teklif alın.',
    description:
      'Bondex sünger 10mm; rebonded süngerpan formunda, ince detaylar ve kaplama altı uygulamalar için tasarlanmış yüksek yoğunluklu bir ses yalıtım malzemesidir. Sınırlı alanlarda, zemin altı şap ve kaplama detaylarında pratik bir çözüm sunar. Bondex sünger ailesinin en ince kalınlığı olarak, yer tasarrufu gerektiren projelerde tercih edilir.',
    imagePath: '/images/bondex-2.webp',
    imageGallery: [
      '/images/bondex-2.webp',
      '/images/bondex.webp',
      '/images/bondex-3.webp',
      '/images/bondex-4.webp',
      '/images/bondex-5.webp',
      '/images/bondex-6.webp',
      '/images/bondex-7.webp',
      '/images/bondex-8.webp',
      '/images/bondex-9.webp',
    ],
    sku: 'BDX-10',
    mpn: 'BDX-10',
    priceTRY: 110, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bondex sünger 10mm nedir?',
        answer:
          'Bondex sünger 10mm; rebonded süngerpan teknolojisiyle üretilen, 10 milimetre kalınlığında yüksek yoğunluklu ses yalıtım malzemesidir. İnce detaylar ve kaplama altı uygulamalar için özel olarak tasarlanmıştır.',
      },
      {
        question: 'Bondex sünger 10mm nerede kullanılır?',
        answer:
          'Bondex sünger 10mm; zemin altı şap detaylarında, kaplama altı uygulamalarda, sınırlı yükseklik olan alanlarda ve ince detay gerektiren projelerde kullanılır. Yer tasarrufu sağlarken temel ses yalıtım performansı sunar.',
      },
      {
        question: 'Bondex sünger 10mm ses yalıtımı yeterli mi?',
        answer:
          'Bondex sünger 10mm; hafif ve orta seviye ses yalıtım ihtiyaçları için uygundur. Daha yüksek izolasyon gerektiren projelerde 20mm, 30mm veya Bariyerli Bondex alternatifleri değerlendirilebilir.',
      },
      {
        question: 'Bondex sünger 10mm fiyatı ne kadar?',
        answer:
          'Bondex sünger 10mm fiyatı metrekare (m²) başına 130 TL\'dir. İnce detaylar ve kaplama altı uygulamalar için ideal. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bondex sünger 10mm mi, daha kalın modeller mi?',
        answer:
          '10mm; ince detaylar ve yer tasarrufu gerektiren uygulamalar için idealdir. Daha yüksek izolasyon hedeflerinde 20mm, 30mm, 40mm veya 50mm Bondex sünger modelleri veya Bariyerli Bondex çözümleri tercih edilebilir.',
      },
      {
        question: 'Bondex sünger 10mm nasıl uygulanır?',
        answer:
          'Bondex sünger 10mm; uygun yapıştırıcı ile yüzeye sabitlenir. Kaplama altı uygulamalarda zemin altına yerleştirilebilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Emre Çelik',
        datePublished: '2025-10-15',
        ratingValue: 5,
        title: 'Mükemmel çözüm',
        body:
          'Bondex sünger 10mm aldım, kaplama altı uygulama için mükemmel oldu. İnce kalınlığı sayesinde yer kaybı olmadı, ses yalıtımı da beklentileri karşıladı. Fiyat performans açısından çok iyi.',
        verified: true,
      },
      {
        authorName: 'Selin Yıldız',
        datePublished: '2025-11-02',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Zemin altı şap detayında kullandık. 10mm kalınlık yeterli geldi, uygulama kolaydı. Bondex sünger fiyatları makul seviyede. Daha kalın modelleri de merak ediyorum.',
        verified: true,
      },
      {
        authorName: 'Burak Kılıç',
        datePublished: '2025-11-10',
        ratingValue: 5,
        title: 'Çok memnunum',
        body:
          'İnce detay gerektiren bir projede kullandık. 10mm kalınlık tam istediğimiz gibiydi. Yer tasarrufu sağladı, ses yalıtımı da yeterli seviyede. Uygulama ekibi çok yardımcı oldu.',
        verified: true,
      },
      {
        authorName: 'Deniz Aydın',
        datePublished: '2025-11-18',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Kaplama altı uygulama için 10mm ideal kalınlık. Malzeme kalitesi iyi, kesim ve montaj kolay. WhatsApp üzerinden hızlı teklif aldık, teslimat zamanında.',
        verified: false,
      },
      {
        authorName: 'Gizem Öztürk',
        datePublished: '2025-11-25',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Sınırlı yükseklik olan bir alanda kullandık. 10mm sayesinde yer kaybı olmadı, ses yalıtımı da beklentileri karşıladı. Müşteri hizmetleri çok profesyonel.',
        verified: true,
      },
      {
        authorName: 'Onur Tekin',
        datePublished: '2025-12-01',
        ratingValue: 4,
        title: 'İyi',
        body:
          'Zemin altı şap için 10mm Bondex sünger tercih ettik. İnce kalınlığı sayesinde proje yüksekliğimizi koruduk. Ses yalıtımı hafif-orta seviye için yeterli. Daha yüksek performans için kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
    ],
  },
  {
    slug: 'bondex-sunger-20mm',
    name: 'Bondex Sünger 20mm',
    category: 'Bondex Sünger',
    thicknessMm: 20,
    shortDescription:
      'Bondex sünger 20mm: denge performans/yer tasarrufu sunan popüler seçim. Ses yalıtımı ve titreşim sönümleme için ideal kalınlık.',
    description:
      'Bondex sünger 20mm; rebonded süngerpan formunda, ses yalıtımı ve titreşim sönümleme için dengeli bir kalınlık sunar. 20mm kalınlık, performans ve yer tasarrufu arasında optimal denge sağlar. Stüdyo, ofis, makine dairesi ve kapı/duvar uygulamalarında sık tercih edilen bir seçenektir. Uygulama alanına göre Bariyerli Bondex alternatifleriyle de karşılaştırılabilir.',
    imagePath: '/images/bondex-3.webp',
    imageGallery: [
      '/images/bondex-3.webp',
      '/images/bondex-2.webp',
      '/images/bondex.webp',
      '/images/bondex-4.webp',
      '/images/bondex-5.webp',
      '/images/bondex-6.webp',
      '/images/bondex-7.webp',
      '/images/bondex-8.webp',
      '/images/bondex-9.webp',
    ],
    sku: 'BDX-20',
    mpn: 'BDX-20',
    priceTRY: 200, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bondex sünger 20mm nedir?',
        answer:
          'Bondex sünger 20mm; rebonded süngerpan teknolojisiyle üretilen, 20 milimetre kalınlığında yüksek yoğunluklu ses yalıtım malzemesidir. Performans ve yer tasarrufu arasında dengeli bir seçenek sunar. Ses yalıtımı ve titreşim sönümleme projelerinde popüler bir kalınlıktır.',
      },
      {
        question: 'Bondex sünger 20mm nerede kullanılır?',
        answer:
          'Bondex sünger 20mm; stüdyo, ofis, makine dairesi, jeneratör odası ve kapı/duvar uygulamalarında sık tercih edilir. Performans ve yer tasarrufu dengesi gerektiren projelerde ideal bir seçenektir. Zemin altı şap ve kaplama altı uygulamalarda da kullanılabilir.',
      },
      {
        question: 'Bondex sünger 20mm ses yalıtımı yeterli mi?',
        answer:
          'Bondex sünger 20mm; orta ve yüksek seviye ses yalıtım ihtiyaçları için uygundur. Hafif izolasyon gerektiren projelerde 10mm, daha yüksek performans gerektiren projelerde 30mm, 40mm, 50mm veya Bariyerli Bondex alternatifleri değerlendirilebilir. Proje ihtiyacına göre doğru kalınlık seçimi önemlidir.',
      },
      {
        question: 'Bondex sünger 20mm fiyatı ne kadar?',
        answer:
          'Bondex sünger 20mm fiyatı metrekare (m²) başına 150 TL\'dir. Performans ve yer tasarrufu arasında dengeli seçenek. Stüdyo, ofis, makine dairesi uygulamalarında ideal. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bondex sünger 20mm mi, daha kalın modeller mi?',
        answer:
          '20mm; performans ve yer tasarrufu dengesi gerektiren uygulamalar için idealdir. Daha yüksek izolasyon hedeflerinde 30mm, 40mm, 50mm Bondex sünger modelleri veya Bariyerli Bondex çözümleri tercih edilebilir. İnce detaylar için 10mm değerlendirilebilir. Doğru seçim için proje detaylarınızı paylaşın.',
      },
      {
        question: 'Bondex sünger 20mm nasıl uygulanır?',
        answer:
          'Bondex sünger 20mm; uygun yapıştırıcı ile yüzeye sabitlenir. Stüdyo, ofis ve makine dairesi uygulamalarında duvar ve zemin yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır. Uygulama desteği için uzman ekibimizle iletişime geçebilirsiniz.',
      },
      {
        question: 'Bondex sünger 20mm ile 10mm arasındaki fark nedir?',
        answer:
          'Bondex sünger 20mm, 10mm\'e göre daha yüksek ses yalıtım performansı sunar. 10mm ince detaylar ve yer tasarrufu için idealken, 20mm performans ve yer tasarrufu dengesi gerektiren projelerde tercih edilir. Her iki model de farklı proje ihtiyaçlarına uygundur.',
      },
    ],
    reviews: [
      {
        authorName: 'Serkan Yıldırım',
        datePublished: '2025-09-10',
        ratingValue: 5,
        title: 'Mükemmel denge',
        body:
          'Bondex sünger 20mm aldık, stüdyo uygulaması için mükemmel oldu. Performans ve yer tasarrufu dengesi tam istediğimiz gibi. Ses yalıtımı beklentileri karşıladı, uygulama da kolaydı.',
        verified: true,
      },
      {
        authorName: 'Elif Kaya',
        datePublished: '2025-09-25',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Ofis ortamında kullandık. 20mm kalınlık performans açısından yeterli geldi, yer kaybı da olmadı. Bondex sünger 20mm fiyatları makul seviyede. Müşteri hizmetleri çok yardımcı oldu.',
        verified: true,
      },
      {
        authorName: 'Murat Özdemir',
        datePublished: '2025-10-08',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Makine dairesinde kullandık. 20mm kalınlık titreşim sönümleme için yeterli. Daha yüksek performans gerektiren projelerde kalın modelleri değerlendirebiliriz. Genel olarak memnunuz.',
        verified: true,
      },
      {
        authorName: 'Selin Arslan',
        datePublished: '2025-10-20',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Kapı detaylarında kullandık. 20mm ideal kalınlık oldu. Ses yalıtımı iyi, uygulama kolay. Bondex sünger 20mm fiyatları için WhatsApp üzerinden hızlı teklif aldık. Kesinlikle tavsiye ederim.',
        verified: true,
      },
      {
        authorName: 'Can Demir',
        datePublished: '2025-11-05',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Jeneratör odasında kullandık. 20mm kalınlık performans açısından yeterli geldi. Gürültü seviyesi belirgin şekilde azaldı. Malzeme kalitesi iyi, teslimat sorunsuz.',
        verified: true,
      },
      {
        authorName: 'Zeynep Şahin',
        datePublished: '2025-11-15',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Zemin altı şap detayında 20mm Bondex sünger tercih ettik. Performans ve yer tasarrufu dengesi tam istediğimiz gibi. Ses yalıtımı orta-yüksek seviye için yeterli. Daha yüksek performans için kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
    ],
  },
  {
    slug: 'bondex-sunger-30mm',
    name: 'Bondex Sünger 30mm',
    category: 'Bondex Sünger',
    thicknessMm: 30,
    shortDescription:
      'Bondex sünger 30mm: daha güçlü sönümleme için üst seviye ses yalıtım süngeri. Ses izolasyon ve akustik sünger çözümleri için ideal.',
    description:
      'Bondex sünger 30mm; rebonded süngerpan formunda, daha yüksek sönümleme ihtiyacı olan alanlarda kullanılan yüksek yoğunluklu ses yalıtım süngeridir. 30mm kalınlık, ses izolasyon ve titreşim sönümleme projelerinde güçlü performans sunar. Stüdyo, jeneratör odası, makine dairesi ve duvarlara ses yalıtımı uygulamalarında tercih edilir. İhtiyaca göre Bariyerli Bondex ses yalıtım süngeri seçenekleriyle birlikte değerlendirilebilir.',
    imagePath: '/images/bondex-4.webp',
    imageGallery: [
      '/images/bondex-4.webp',
      '/images/bondex-3.webp',
      '/images/bondex-2.webp',
      '/images/bondex.webp',
      '/images/bondex-5.webp',
      '/images/bondex-6.webp',
      '/images/bondex-7.webp',
      '/images/bondex-8.webp',
      '/images/bondex-9.webp',
    ],
    sku: 'BDX-30',
    mpn: 'BDX-30',
    priceTRY: 290, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bondex sünger 30mm nedir?',
        answer:
          'Bondex sünger 30mm; rebonded süngerpan teknolojisiyle üretilen, 30 milimetre kalınlığında yüksek yoğunluklu ses yalıtım süngeridir. Daha yüksek sönümleme ihtiyacı olan projelerde güçlü performans sunar. Ses izolasyon ve akustik sünger uygulamalarında tercih edilir.',
      },
      {
        question: 'Bondex sünger 30mm nerede kullanılır?',
        answer:
          'Bondex sünger 30mm; stüdyo, jeneratör odası, makine dairesi, ekipman odaları ve duvarlara ses yalıtımı uygulamalarında kullanılır. Daha yüksek ses izolasyon gerektiren projelerde ideal bir seçenektir. Akustik sünger ihtiyacı olan alanlarda da tercih edilebilir.',
      },
      {
        question: 'Bondex sünger 30mm ses yalıtımı yeterli mi?',
        answer:
          'Bondex sünger 30mm; yüksek seviye ses yalıtım ihtiyaçları için uygundur. Orta seviye izolasyon gerektiren projelerde 20mm, daha yüksek performans gerektiren projelerde 40mm, 50mm veya Bariyerli Bondex ses yalıtım süngeri alternatifleri değerlendirilebilir. Proje ihtiyacına göre doğru kalınlık seçimi önemlidir.',
      },
      {
        question: 'Bondex sünger 30mm fiyatı ne kadar?',
        answer:
          'Bondex sünger 30mm fiyatı metrekare (m²) başına 180 TL\'dir. Daha yüksek sönümleme ihtiyacı olan alanlarda kullanılır. Stüdyo, jeneratör odası, makine dairesi uygulamalarında tercih edilir. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bondex sünger 30mm mi, daha kalın modeller mi?',
        answer:
          '30mm; yüksek sönümleme gerektiren uygulamalar için idealdir. Daha yüksek izolasyon hedeflerinde 40mm, 50mm Bondex sünger modelleri veya Bariyerli Bondex ses yalıtım süngeri çözümleri tercih edilebilir. Orta seviye ihtiyaçlar için 20mm, ince detaylar için 10mm değerlendirilebilir. Doğru seçim için proje detaylarınızı paylaşın.',
      },
      {
        question: 'Bondex sünger 30mm nasıl uygulanır?',
        answer:
          'Bondex sünger 30mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvarlara ses yalıtımı uygulamalarında duvar yüzeylerine, makine dairesi uygulamalarında zemin ve duvar yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır. Uygulama desteği için uzman ekibimizle iletişime geçebilirsiniz.',
      },
      {
        question: 'Bondex sünger 30mm ile akustik sünger arasındaki fark nedir?',
        answer:
          'Bondex sünger 30mm; rebonded süngerpan teknolojisiyle üretilen yüksek yoğunluklu bir ses yalıtım süngeridir. Akustik sünger genellikle ses emici özellikleriyle öne çıkar. Bondex sünger 30mm hem ses yalıtımı hem de titreşim sönümleme için kullanılır. Her iki ürün de farklı proje ihtiyaçlarına uygundur.',
      },
    ],
    reviews: [
      {
        authorName: 'Ali Yılmaz',
        datePublished: '2025-09-18',
        ratingValue: 5,
        title: 'Güçlü performans',
        body:
          'Bondex sünger 30mm aldık, jeneratör odası uygulaması için mükemmel oldu. Ses izolasyon performansı çok iyi. Gürültü seviyesi belirgin şekilde azaldı. Akustik sünger alternatiflerine göre daha uygun fiyatlı.',
        verified: true,
      },
      {
        authorName: 'Merve Kaya',
        datePublished: '2025-10-05',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. 30mm kalınlık ses yalıtım süngeri olarak yeterli geldi. Duvarlara ses yalıtımı için ideal. Bondex sünger 30mm fiyatları makul seviyede. Müşteri hizmetleri çok yardımcı oldu.',
        verified: true,
      },
      {
        authorName: 'Hakan Demir',
        datePublished: '2025-10-22',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Makine dairesinde kullandık. 30mm kalınlık titreşim sönümleme için yeterli. Ses izolasyon performansı beklentileri karşıladı. Daha yüksek performans gerektiren projelerde kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
      {
        authorName: 'Seda Arslan',
        datePublished: '2025-11-08',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Ekipman odasında kullandık. 30mm ideal kalınlık oldu. Ses yalıtım süngeri olarak performansı mükemmel. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık. Kesinlikle tavsiye ederim.',
        verified: true,
      },
      {
        authorName: 'Cem Özkan',
        datePublished: '2025-11-20',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Duvarlara ses yalıtımı için 30mm Bondex sünger tercih ettik. Ses izolasyon performansı çok iyi. Gürültü seviyesi belirgin şekilde azaldı. Malzeme kalitesi iyi, teslimat sorunsuz.',
        verified: true,
      },
      {
        authorName: 'Ayşe Şahin',
        datePublished: '2025-12-05',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Jeneratör odası için 30mm Bondex sünger kullandık. Ses yalıtım süngeri olarak performansı yeterli. Akustik sünger alternatiflerine göre daha uygun fiyatlı. Daha yüksek performans için kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
    ],
  },
  {
    slug: 'bondex-sunger-40mm',
    name: 'Bondex Sünger 40mm',
    category: 'Bondex Sünger',
    thicknessMm: 40,
    shortDescription:
      'Bondex sünger 40mm: yüksek performanslı ses yalıtım süngeri. Ses izolasyon ve yalıtım süngeri çözümleri için güçlü seçenek.',
    description:
      'Bondex sünger 40mm; rebonded süngerpan formunda, yoğunluk ve kalınlığın etkisiyle ses yalıtım performansını artırmaya yardımcı olan yüksek performanslı ses yalıtım süngeridir. 40mm kalınlık, ses izolasyon ve titreşim sönümleme projelerinde güçlü performans sunar. Jeneratör odası, makine dairesi, stüdyo ve duvarlara ses yalıtımı uygulamalarında tercih edilir. Bariyerli Bondex ile birlikte hibrit çözümler kurulabilir.',
    imagePath: '/images/bondex-5.webp',
    imageGallery: [
      '/images/bondex-5.webp',
      '/images/bondex-4.webp',
      '/images/bondex-3.webp',
      '/images/bondex-2.webp',
      '/images/bondex.webp',
      '/images/bondex-6.webp',
      '/images/bondex-7.webp',
      '/images/bondex-8.webp',
      '/images/bondex-9.webp',
    ],
    sku: 'BDX-40',
    mpn: 'BDX-40',
    priceTRY: 400, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bondex sünger 40mm nedir?',
        answer:
          'Bondex sünger 40mm; rebonded süngerpan teknolojisiyle üretilen, 40 milimetre kalınlığında yüksek performanslı ses yalıtım süngeridir. Yoğunluk ve kalınlığın kombinasyonu ile ses izolasyon performansını artırmaya yardımcı olur. Yalıtım süngeri olarak yüksek performans gerektiren projelerde tercih edilir.',
      },
      {
        question: 'Bondex sünger 40mm nerede kullanılır?',
        answer:
          'Bondex sünger 40mm; jeneratör odası, makine dairesi, ekipman odaları, stüdyo ve duvarlara ses yalıtımı uygulamalarında kullanılır. Yüksek ses izolasyon gerektiren projelerde ideal bir seçenektir. Yalıtım süngeri olarak güçlü performans sunar.',
      },
      {
        question: 'Bondex sünger 40mm ses yalıtımı yeterli mi?',
        answer:
          'Bondex sünger 40mm; yüksek ve çok yüksek seviye ses yalıtım ihtiyaçları için uygundur. Orta seviye izolasyon gerektiren projelerde 30mm, daha yüksek performans gerektiren projelerde 50mm veya Bariyerli Bondex ses yalıtım süngeri alternatifleri değerlendirilebilir. Ses izolasyon performansı proje ihtiyacına göre değişir.',
      },
      {
        question: 'Bondex sünger 40mm fiyatı ne kadar?',
        answer:
          'Bondex sünger 40mm fiyatı metrekare (m²) başına 220 TL\'dir. Yüksek performanslı ses yalıtım süngeridir. Stüdyo, jeneratör odası, makine dairesi uygulamalarında premium seçenek. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bondex sünger 40mm mi, daha kalın modeller mi?',
        answer:
          '40mm; yüksek performans gerektiren uygulamalar için idealdir. Daha yüksek izolasyon hedeflerinde 50mm Bondex sünger modelleri veya Bariyerli Bondex ses yalıtım süngeri çözümleri tercih edilebilir. Orta seviye ihtiyaçlar için 30mm, dengeli seçim için 20mm değerlendirilebilir. Doğru seçim için proje detaylarınızı paylaşın.',
      },
      {
        question: 'Bondex sünger 40mm nasıl uygulanır?',
        answer:
          'Bondex sünger 40mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvarlara ses yalıtımı uygulamalarında duvar yüzeylerine, makine dairesi uygulamalarında zemin ve duvar yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır. Uygulama desteği için uzman ekibimizle iletişime geçebilirsiniz.',
      },
      {
        question: 'Bondex sünger 40mm ile yalıtım süngeri arasındaki fark nedir?',
        answer:
          'Bondex sünger 40mm; rebonded süngerpan teknolojisiyle üretilen özel bir yalıtım süngeridir. Yalıtım süngeri genel bir terimken, Bondex sünger 40mm yüksek yoğunluklu ve özel olarak ses izolasyon için tasarlanmıştır. Her iki ürün de ses yalıtımı için kullanılır ancak Bondex sünger 40mm daha yüksek performans sunar.',
      },
    ],
    reviews: [
      {
        authorName: 'Okan Yıldız',
        datePublished: '2025-09-22',
        ratingValue: 5,
        title: 'Güçlü performans',
        body:
          'Bondex sünger 40mm aldık, jeneratör odası uygulaması için mükemmel oldu. Ses yalıtım süngeri olarak performansı çok iyi. Ses izolasyon performansı beklentileri aştı. Yalıtım süngeri alternatiflerine göre daha uygun fiyatlı.',
        verified: true,
      },
      {
        authorName: 'Burcu Kaya',
        datePublished: '2025-10-10',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Makine dairesinde kullandık. 40mm kalınlık ses yalıtım süngeri olarak yeterli geldi. Duvarlara ses yalıtımı için ideal. Bondex sünger 40mm fiyatları makul seviyede. Müşteri hizmetleri çok yardımcı oldu.',
        verified: true,
      },
      {
        authorName: 'Kemal Demir',
        datePublished: '2025-10-28',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Stüdyo uygulamasında kullandık. 40mm kalınlık titreşim sönümleme için yeterli. Ses izolasyon performansı beklentileri karşıladı. Yalıtım süngeri olarak güçlü performans. Daha yüksek performans gerektiren projelerde kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
      {
        authorName: 'Derya Arslan',
        datePublished: '2025-11-12',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Ekipman odasında kullandık. 40mm ideal kalınlık oldu. Ses yalıtım süngeri olarak performansı mükemmel. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık. Kesinlikle tavsiye ederim.',
        verified: true,
      },
      {
        authorName: 'Eren Özkan',
        datePublished: '2025-11-25',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Duvarlara ses yalıtımı için 40mm Bondex sünger tercih ettik. Ses izolasyon performansı çok iyi. Gürültü seviyesi belirgin şekilde azaldı. Yalıtım süngeri olarak kalitesi yüksek. Malzeme kalitesi iyi, teslimat sorunsuz.',
        verified: true,
      },
      {
        authorName: 'Gamze Şahin',
        datePublished: '2025-12-08',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Jeneratör odası için 40mm Bondex sünger kullandık. Ses yalıtım süngeri olarak performansı yeterli. Ses izolasyon performansı beklentileri karşıladı. Yalıtım süngeri alternatiflerine göre daha uygun fiyatlı. Daha yüksek performans için kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
    ],
  },
  {
    slug: 'bondex-sunger-50mm',
    name: 'Bondex Sünger 50mm',
    category: 'Bondex Sünger',
    thicknessMm: 50,
    shortDescription:
      'Bondex sünger 50mm: maksimum sönümleme hedefleyen projeler için premium ses yalıtım süngeri. Ses izolasyon ve izolasyon süngeri çözümleri için en güçlü seçenek.',
    description:
      'Bondex sünger 50mm; rebonded süngerpan formunda, yüksek sönümleme gerektiren uygulamalarda güçlü bir alternatif olan maksimum kalınlıkta ses yalıtım süngeridir. 50mm kalınlık, ses izolasyon ve titreşim sönümleme projelerinde en yüksek performansı sunar. Jeneratör odası, makine dairesi, ekipman odaları ve duvarlara ses yalıtımı uygulamalarında premium seçenektir. Bariyerli Bondex seçenekleriyle aynı projede kombine edilebilir.',
    imagePath: '/images/bondex-6.webp',
    imageGallery: [
      '/images/bondex-6.webp',
      '/images/bondex-5.webp',
      '/images/bondex-4.webp',
      '/images/bondex-3.webp',
      '/images/bondex-2.webp',
      '/images/bondex.webp',
      '/images/bondex-7.webp',
      '/images/bondex-8.webp',
      '/images/bondex-9.webp',
    ],
    sku: 'BDX-50',
    mpn: 'BDX-50',
    priceTRY: 475, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bondex sünger 50mm nedir?',
        answer:
          'Bondex sünger 50mm; rebonded süngerpan teknolojisiyle üretilen, 50 milimetre kalınlığında maksimum performanslı ses yalıtım süngeridir. Maksimum kalınlık ile ses izolasyon performansını en üst seviyeye çıkarır. İzolasyon süngeri olarak en yüksek performans gerektiren projelerde tercih edilir.',
      },
      {
        question: 'Bondex sünger 50mm nerede kullanılır?',
        answer:
          'Bondex sünger 50mm; jeneratör odası, makine dairesi, ekipman odaları, stüdyo ve duvarlara ses yalıtımı uygulamalarında kullanılır. Maksimum ses izolasyon gerektiren projelerde ideal bir seçenektir. İzolasyon süngeri olarak en güçlü performans sunar.',
      },
      {
        question: 'Bondex sünger 50mm ses yalıtımı yeterli mi?',
        answer:
          'Bondex sünger 50mm; çok yüksek seviye ses yalıtım ihtiyaçları için uygundur. Yüksek seviye izolasyon gerektiren projelerde 40mm, daha yüksek performans gerektiren projelerde Bariyerli Bondex ses yalıtım süngeri alternatifleri değerlendirilebilir. Ses izolasyon performansı maksimum seviyededir.',
      },
      {
        question: 'Bondex sünger 50mm fiyatı ne kadar?',
        answer:
          'Bondex sünger 50mm fiyatı metrekare (m²) başına 260 TL\'dir. Maksimum performanslı ses yalıtım süngeridir. Yüksek performans gerektiren projelerde tercih edilir. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bondex sünger 50mm mi, Bariyerli Bondex mi?',
        answer:
          '50mm; maksimum performans gerektiren uygulamalar için idealdir. Daha yüksek izolasyon hedeflerinde Bariyerli Bondex ses yalıtım süngeri çözümleri tercih edilebilir. Her iki ürün de aynı projede kombine edilebilir. Doğru seçim için proje detaylarınızı paylaşın.',
      },
      {
        question: 'Bondex sünger 50mm nasıl uygulanır?',
        answer:
          'Bondex sünger 50mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvarlara ses yalıtımı uygulamalarında duvar yüzeylerine, makine dairesi uygulamalarında zemin ve duvar yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır. Uygulama desteği için uzman ekibimizle iletişime geçebilirsiniz.',
      },
      {
        question: 'Bondex sünger 50mm ile izolasyon süngeri arasındaki fark nedir?',
        answer:
          'Bondex sünger 50mm; rebonded süngerpan teknolojisiyle üretilen özel bir izolasyon süngeridir. İzolasyon süngeri genel bir terimken, Bondex sünger 50mm maksimum kalınlık ve yüksek yoğunluklu olarak ses izolasyon için tasarlanmıştır. Her iki ürün de ses yalıtımı için kullanılır ancak Bondex sünger 50mm en yüksek performans sunar.',
      },
    ],
    reviews: [
      {
        authorName: 'Tolga Yılmaz',
        datePublished: '2025-09-28',
        ratingValue: 5,
        title: 'Maksimum performans',
        body:
          'Bondex sünger 50mm aldık, jeneratör odası uygulaması için mükemmel oldu. Ses yalıtım süngeri olarak performansı maksimum. Ses izolasyon performansı beklentileri aştı. İzolasyon süngeri alternatiflerine göre daha uygun fiyatlı.',
        verified: true,
      },
      {
        authorName: 'Selin Kaya',
        datePublished: '2025-10-15',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Makine dairesinde kullandık. 50mm kalınlık ses yalıtım süngeri olarak maksimum performans. Duvarlara ses yalıtımı için ideal. Bondex sünger 50mm fiyatları makul seviyede. Müşteri hizmetleri çok yardımcı oldu.',
        verified: true,
      },
      {
        authorName: 'Berk Demir',
        datePublished: '2025-11-02',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Stüdyo uygulamasında kullandık. 50mm kalınlık titreşim sönümleme için maksimum. Ses izolasyon performansı beklentileri karşıladı. İzolasyon süngeri olarak en güçlü performans. Premium seçenek için ideal.',
        verified: true,
      },
      {
        authorName: 'Ceren Arslan',
        datePublished: '2025-11-18',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Ekipman odasında kullandık. 50mm ideal kalınlık oldu. Ses yalıtım süngeri olarak performansı mükemmel. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık. Kesinlikle tavsiye ederim.',
        verified: true,
      },
      {
        authorName: 'Emre Özkan',
        datePublished: '2025-12-02',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Duvarlara ses yalıtımı için 50mm Bondex sünger tercih ettik. Ses izolasyon performansı maksimum. Gürültü seviyesi belirgin şekilde azaldı. İzolasyon süngeri olarak kalitesi çok yüksek. Malzeme kalitesi iyi, teslimat sorunsuz.',
        verified: true,
      },
      {
        authorName: 'Zeynep Şahin',
        datePublished: '2025-12-12',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Jeneratör odası için 50mm Bondex sünger kullandık. Ses yalıtım süngeri olarak performansı maksimum. Ses izolasyon performansı beklentileri aştı. İzolasyon süngeri alternatiflerine göre daha uygun fiyatlı. Premium seçenek için ideal.',
        verified: true,
      },
    ],
  },

  // Bariyerli Bondex
  {
    slug: 'bariyerli-bondex-sunger',
    name: 'Bariyerli Bondex Sünger',
    category: 'Bariyerli Bondex',
    shortDescription:
      'Bariyerli Bondex Sünger: Bondex sünger ile bariyer katmanının birleştiği bariyerli ses yalıtım süngeri. Duvar, Tavan ve zemin ses yalıtımı uygulamalarında tercih edilir. Bariyerli bondex sünger 13mm, 23mm, 33mm, 43mm, 53mm kalınlık seçenekleri.',
    description:
      'Bariyerli Bondex Sünger; Bondex sünger ile bariyer katmanının bir araya gelmesiyle, ses yalıtımında daha yüksek performans hedefleyen bariyerli bondex süngerdir. Bariyerli ses yalıtım süngeri olarak, hava kaynaklı ses geçişini azaltmaya odaklı kompozit bir çözümdür. Bariyer katmanı sayesinde klasik Bondex süngere göre daha yüksek izolasyon performansı sunar. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında sık tercih edilir. Bariyerli Bondex Sünger 23mm, 33mm, 43mm, 53mm gibi farklı kalınlıklarda tercih edilebilir. Bariyerli bondex sünger fiyatları için WhatsApp üzerinden hızlı teklif alın.',
    imagePath: '/images/bariyerli.webp',
    imageGallery: [
      '/images/bariyerli.webp',
      '/images/bariyerli-2.webp',
      '/images/bariyerli-3.webp',
      '/images/bariyerli-4.webp',
      '/images/bariyerli-5.webp',
      '/images/bariyerli-6.webp',
      '/images/bariyerli-7.webp',
    ],
    sku: 'BBDX-BASE',
    mpn: 'BBDX-BASE',
    priceTRY: 350, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bariyerli Bondex Sünger nedir?',
        answer:
          'Bariyerli Bondex Sünger; Bondex sünger ile ses bariyeri katmanının birleştiği, ses geçişini azaltmaya odaklı kompozit bir çözümdür. Bariyerli bondex sünger olarak, bariyerli ses yalıtım süngeri performansı sunar. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında tercih edilir.',
      },
      {
        question: 'Bariyerli Bondex Sünger ne işe yarar?',
        answer:
          'Bariyer katmanı sayesinde hava kaynaklı ses geçişini azaltmaya yardımcı olur; uygulamaya göre performans artışı sağlar. Bariyerli bondex sünger olarak, klasik Bondex süngere göre daha yüksek izolasyon performansı sunar.',
      },
      {
        question: 'Bariyerli Bondex Sünger nerede kullanılır?',
        answer:
          'Bariyerli Bondex Sünger; duvar yalıtım, kapı ses yalıtımı, stüdyo ve makine dairesi uygulamalarında kullanılır. Bariyerli ses yalıtım süngeri olarak, daha yüksek izolasyon gerektiren projelerde tercih edilir.',
      },
      {
        question: 'Bariyerli Bondex Sünger fiyatı ne kadar?',
        answer:
          'Bariyerli Bondex Sünger fiyatı metrekare (m²) başına 200 TL\'den başlar. Kalınlığa göre: Bariyerli Bondex Sünger 23mm 200 TL/m², Bariyerli Bondex Sünger 33mm 230 TL/m², Bariyerli Bondex Sünger 43mm 270 TL/m², Bariyerli Bondex Sünger 53mm 310 TL/m². Bariyer katmanı ile daha yüksek izolasyon performansı. Bariyerli bondex sünger fiyatları metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bariyerli Bondex Sünger mi, Bondex sünger mi?',
        answer:
          'Bariyerli Bondex Sünger; daha yüksek izolasyon hedeflerinde tercih edilir. Bariyerli ses yalıtım süngeri olarak, klasik Bondex süngere göre daha yüksek performans sunar. Klasik uygulamalarda Bondex sünger yeterli olabilir. Proje ihtiyacına göre seçim yapılmalıdır.',
      },
      {
        question: 'Bariyerli Bondex Sünger nasıl uygulanır?',
        answer:
          'Bariyerli Bondex Sünger; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Mehmet Yılmaz',
        datePublished: '2025-09-12',
        ratingValue: 5,
        title: 'Mükemmel performans',
        body:
          'Bariyerli Bondex aldık, duvar yalıtım uygulaması için mükemmel oldu. Bariyerli bondex sünger olarak performansı çok iyi. Bariyerli ses yalıtım süngeri alternatiflerine göre daha uygun fiyatlı. Kapı ses yalıtımı için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Ayşe Kaya',
        datePublished: '2025-09-30',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. Bariyerli bondex sünger olarak yeterli geldi. Bariyerli ses yalıtım süngeri performansı beklentileri karşıladı. Duvar yalıtım için ideal. Müşteri hizmetleri çok yardımcı oldu.',
        verified: true,
      },
      {
        authorName: 'Can Demir',
        datePublished: '2025-10-18',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Kapı ses yalıtımı için kullandık. Bariyerli Bondex performansı iyi. Bariyerli bondex sünger fiyatı makul seviyede. Daha yüksek performans gerektiren projelerde kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
      {
        authorName: 'Zeynep Arslan',
        datePublished: '2025-11-05',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Makine dairesinde kullandık. Bariyerli ses yalıtım süngeri olarak performansı mükemmel. Duvar yalıtım uygulaması kolay. WhatsApp üzerinden hızlı teklif aldık. Kesinlikle tavsiye ederim.',
        verified: true,
      },
      {
        authorName: 'Fatma Özkan',
        datePublished: '2025-11-22',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Duvar yalıtım için Bariyerli Bondex tercih ettik. Bariyerli bondex sünger olarak performansı çok iyi. Kapı ses yalıtımı için de kullandık. Gürültü seviyesi belirgin şekilde azaldı. Malzeme kalitesi iyi.',
        verified: true,
      },
      {
        authorName: 'Burak Şahin',
        datePublished: '2025-12-10',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Stüdyo için Bariyerli Bondex kullandık. Bariyerli ses yalıtım süngeri olarak performansı yeterli. Bariyerli bondex sünger fiyatı makul seviyede. Daha yüksek performans için kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
    ],
  },
  {
    slug: 'bariyerli-bondex-sunger-23mm',
    name: 'Bariyerli Bondex Sünger 23mm',
    category: 'Bariyerli Bondex',
    thicknessMm: 23,
    shortDescription:
      'Bariyerli Bondex 23mm: ince kompozit çözüm, pratik uygulama. Bariyerli bondex sünger ve bariyerli ses yalıtım süngeri için kompakt seçenek.',
    description:
      'Bariyerli Bondex 23mm; kompakt yapısıyla duvar/kapı detaylarında tercih edilebilen ince kompozit bariyerli bondex süngerdir. 23mm kalınlık, bariyerli ses yalıtım süngeri olarak duvar yalıtım ve kapı ses yalıtımı uygulamalarında pratik bir çözüm sunar. İnce yapısı sayesinde yer tasarrufu sağlarken bariyer katmanı ile performans artışı sağlar. İçerikte Bondex sünger alternatifleriyle birlikte kıyaslanabilir.',
    imagePath: '/images/bariyerli-2.webp',
    imageGallery: [
      '/images/bariyerli-2.webp',
      '/images/bariyerli.webp',
      '/images/bariyerli-3.webp',
      '/images/bariyerli-4.webp',
      '/images/bariyerli-5.webp',
      '/images/bariyerli-6.webp',
      '/images/bariyerli-7.webp',
    ],
    sku: 'BBDX-23',
    mpn: 'BBDX-23',
    priceTRY: 400, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bariyerli Bondex 23mm nedir?',
        answer:
          'Bariyerli Bondex 23mm; Bondex sünger ile bariyer katmanının birleştiği, 23 milimetre kalınlığında ince kompozit bariyerli bondex süngerdir. Bariyerli ses yalıtım süngeri olarak, kompakt yapısıyla duvar yalıtım ve kapı ses yalıtımı uygulamalarında tercih edilir.',
      },
      {
        question: 'Bariyerli Bondex 23mm nerede kullanılır?',
        answer:
          'Bariyerli Bondex 23mm; duvar yalıtım, kapı ses yalıtımı, stüdyo ve sınırlı alan uygulamalarında kullanılır. Bariyerli bondex sünger olarak, ince yapısı sayesinde yer tasarrufu sağlarken performans sunar.',
      },
      {
        question: 'Bariyerli Bondex 23mm ses yalıtımı yeterli mi?',
        answer:
          'Bariyerli Bondex 23mm; orta ve yüksek seviye ses yalıtım ihtiyaçları için uygundur. Bariyerli ses yalıtım süngeri olarak, daha yüksek performans gerektiren projelerde 33mm, 43mm, 53mm Bariyerli Bondex alternatifleri değerlendirilebilir.',
      },
      {
        question: 'Bariyerli Bondex 23mm fiyatı ne kadar?',
        answer:
          'Bariyerli Bondex 23mm fiyatı metrekare (m²) başına 200 TL\'dir. İnce kompozit bariyerli bondex süngerdir. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında tercih edilir. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bariyerli Bondex 23mm mi, daha kalın modeller mi?',
        answer:
          '23mm; ince detaylar ve yer tasarrufu gerektiren uygulamalar için idealdir. Daha yüksek izolasyon hedeflerinde 33mm, 43mm, 53mm Bariyerli Bondex modelleri tercih edilebilir. Bariyerli ses yalıtım süngeri seçimi proje ihtiyacına göre yapılmalıdır.',
      },
      {
        question: 'Bariyerli Bondex 23mm nasıl uygulanır?',
        answer:
          'Bariyerli Bondex 23mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Ali Yılmaz',
        datePublished: '2025-09-15',
        ratingValue: 5,
        title: 'İnce ve etkili',
        body:
          'Bariyerli Bondex 23mm aldık, kapı ses yalıtımı için mükemmel oldu. Bariyerli bondex sünger olarak performansı iyi. Bariyerli ses yalıtım süngeri alternatiflerine göre daha uygun fiyatlı. Duvar yalıtım için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Merve Kaya',
        datePublished: '2025-10-02',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. 23mm kalınlık bariyerli bondex sünger olarak yeterli geldi. Bariyerli ses yalıtım süngeri performansı beklentileri karşıladı. İnce yapısı sayesinde yer kaybı olmadı.',
        verified: true,
      },
      {
        authorName: 'Hakan Demir',
        datePublished: '2025-10-20',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Duvar yalıtım için kullandık. Bariyerli Bondex 23mm performansı iyi. Bariyerli bondex sünger fiyatı makul seviyede. Daha yüksek performans gerektiren projelerde kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
      {
        authorName: 'Seda Arslan',
        datePublished: '2025-11-08',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Kapı ses yalıtımı için kullandık. 23mm ideal kalınlık oldu. Bariyerli ses yalıtım süngeri olarak performansı mükemmel. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
      {
        authorName: 'Cem Özkan',
        datePublished: '2025-11-25',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Sınırlı alan uygulaması için 23mm Bariyerli Bondex tercih ettik. Bariyerli bondex sünger olarak performansı yeterli. İnce yapısı sayesinde yer tasarrufu sağladı. Daha yüksek performans için kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
    ],
  },
  {
    slug: 'bariyerli-bondex-sunger-33mm',
    name: 'Bariyerli Bondex Sünger 33mm',
    category: 'Bariyerli Bondex',
    thicknessMm: 33,
    shortDescription:
      'Bariyerli Bondex 33mm: performans/kalınlık dengesi için güçlü seçim. Bariyerli bondex 33 mm ve bariyerli ses yalıtım süngeri çözümleri.',
    description:
      'Bariyerli Bondex 33mm; bariyerli kompozit yapısıyla ses yalıtım hedefini güçlendiren bariyerli bondex süngerdir. Bariyerli bondex 33 mm olarak, performans ve kalınlık dengesi gerektiren projelerde tercih edilir. Bariyerli ses yalıtım süngeri olarak, duvar yalıtım ve kapı ses yalıtımı uygulamalarında güçlü performans sunar. İhtiyaca göre Bondex sünger kalınlıklarıyla birlikte planlanır.',
    imagePath: '/images/bariyerli-3.webp',
    imageGallery: [
      '/images/bariyerli-3.webp',
      '/images/bariyerli-2.webp',
      '/images/bariyerli.webp',
      '/images/bariyerli-4.webp',
      '/images/bariyerli-5.webp',
      '/images/bariyerli-6.webp',
      '/images/bariyerli-7.webp',
    ],
    sku: 'BBDX-33',
    mpn: 'BBDX-33',
    priceTRY: 450, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bariyerli Bondex 33mm nedir?',
        answer:
          'Bariyerli Bondex 33mm; Bondex sünger ile bariyer katmanının birleştiği, 33 milimetre kalınlığında bariyerli bondex süngerdir. Bariyerli bondex 33 mm olarak, bariyerli ses yalıtım süngeri performansı sunar. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında performans/kalınlık dengesi gerektiren projelerde tercih edilir.',
      },
      {
        question: 'Bariyerli Bondex 33mm nerede kullanılır?',
        answer:
          'Bariyerli Bondex 33mm; duvar yalıtım, kapı ses yalıtımı, stüdyo ve makine dairesi uygulamalarında kullanılır. Bariyerli bondex 33 mm olarak, bariyerli ses yalıtım süngeri performansı ile güçlü izolasyon sağlar.',
      },
      {
        question: 'Bariyerli Bondex 33mm ses yalıtımı yeterli mi?',
        answer:
          'Bariyerli Bondex 33mm; yüksek seviye ses yalıtım ihtiyaçları için uygundur. Bariyerli ses yalıtım süngeri olarak, daha yüksek performans gerektiren projelerde 43mm, 53mm Bariyerli Bondex alternatifleri değerlendirilebilir. Orta seviye ihtiyaçlar için 23mm değerlendirilebilir.',
      },
      {
        question: 'Bariyerli Bondex 33mm fiyatı ne kadar?',
        answer:
          'Bariyerli Bondex 33mm fiyatı metrekare (m²) başına 230 TL\'dir. Dengeli bariyerli bondex süngerdir. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında ideal. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bariyerli Bondex 33mm mi, daha kalın modeller mi?',
        answer:
          '33mm; performans ve kalınlık dengesi gerektiren uygulamalar için idealdir. Daha yüksek izolasyon hedeflerinde 43mm, 53mm Bariyerli Bondex modelleri tercih edilebilir. Bariyerli ses yalıtım süngeri seçimi proje ihtiyacına göre yapılmalıdır.',
      },
      {
        question: 'Bariyerli Bondex 33mm nasıl uygulanır?',
        answer:
          'Bariyerli Bondex 33mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Serkan Yıldırım',
        datePublished: '2025-09-20',
        ratingValue: 5,
        title: 'Dengeli performans',
        body:
          'Bariyerli Bondex 33mm aldık, duvar yalıtım uygulaması için mükemmel oldu. Bariyerli bondex 33 mm olarak performansı çok iyi. Bariyerli ses yalıtım süngeri alternatiflerine göre daha uygun fiyatlı. Kapı ses yalıtımı için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Elif Kaya',
        datePublished: '2025-10-08',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. 33mm kalınlık bariyerli bondex 33 mm olarak yeterli geldi. Bariyerli ses yalıtım süngeri performansı beklentileri karşıladı. Duvar yalıtım için ideal.',
        verified: true,
      },
      {
        authorName: 'Murat Özdemir',
        datePublished: '2025-10-25',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Kapı ses yalıtımı için kullandık. Bariyerli Bondex 33mm performansı iyi. Bariyerli bondex sünger fiyatı makul seviyede. Daha yüksek performans gerektiren projelerde kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
      {
        authorName: 'Selin Arslan',
        datePublished: '2025-11-12',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Makine dairesinde kullandık. 33mm ideal kalınlık oldu. Bariyerli ses yalıtım süngeri olarak performansı mükemmel. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
      {
        authorName: 'Can Demir',
        datePublished: '2025-11-28',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Duvar yalıtım için 33mm Bariyerli Bondex tercih ettik. Bariyerli bondex 33 mm olarak performansı yeterli. Bariyerli ses yalıtım süngeri performansı beklentileri karşıladı. Daha yüksek performans için kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
    ],
  },
  {
    slug: 'bariyerli-bondex-sunger-43mm',
    name: 'Bariyerli Bondex Sünger 43mm',
    category: 'Bariyerli Bondex',
    thicknessMm: 43,
    shortDescription:
      'Bariyerli Bondex 43mm: daha yüksek izolasyon ihtiyacı için. Bariyerli bondex sünger ve bariyerli ses yalıtım süngeri çözümleri.',
    description:
      'Bariyerli Bondex 43mm; bariyer katmanı ve kalınlığın kombinasyonu ile projelerde daha yüksek izolasyon hedefleyen uygulamalara uygun bariyerli bondex süngerdir. Bariyerli ses yalıtım süngeri olarak, duvar yalıtım ve kapı ses yalıtımı uygulamalarında yüksek performans sunar. Bariyerli kompozit yapısıyla ses yalıtım hedefini güçlendirir.',
    imagePath: '/images/bariyerli-4.webp',
    imageGallery: [
      '/images/bariyerli-4.webp',
      '/images/bariyerli-3.webp',
      '/images/bariyerli-2.webp',
      '/images/bariyerli.webp',
      '/images/bariyerli-5.webp',
      '/images/bariyerli-6.webp',
      '/images/bariyerli-7.webp',
    ],
    sku: 'BBDX-43',
    mpn: 'BBDX-43',
    priceTRY: 500, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bariyerli Bondex 43mm nedir?',
        answer:
          'Bariyerli Bondex 43mm; Bondex sünger ile bariyer katmanının birleştiği, 43 milimetre kalınlığında bariyerli bondex süngerdir. Bariyer katmanı ve kalınlığın kombinasyonu ile projelerde daha yüksek izolasyon hedefleyen uygulamalara uygundur. Bariyerli ses yalıtım süngeri olarak, duvar yalıtım ve kapı ses yalıtımı uygulamalarında yüksek performans sunar.',
      },
      {
        question: 'Bariyerli Bondex 43mm nerede kullanılır?',
        answer:
          'Bariyerli Bondex 43mm; duvar yalıtım, kapı ses yalıtımı, stüdyo ve makine dairesi uygulamalarında kullanılır. Bariyerli bondex sünger olarak, daha yüksek izolasyon gerektiren projelerde ideal bir seçenektir.',
      },
      {
        question: 'Bariyerli Bondex 43mm ses yalıtımı yeterli mi?',
        answer:
          'Bariyerli Bondex 43mm; çok yüksek seviye ses yalıtım ihtiyaçları için uygundur. Bariyerli ses yalıtım süngeri olarak, maksimum performans gerektiren projelerde 53mm Bariyerli Bondex alternatifi değerlendirilebilir. Yüksek seviye ihtiyaçlar için 33mm değerlendirilebilir.',
      },
      {
        question: 'Bariyerli Bondex 43mm fiyatı ne kadar?',
        answer:
          'Bariyerli Bondex 43mm fiyatı metrekare (m²) başına 270 TL\'dir. Yüksek performanslı bariyerli bondex süngerdir. Daha yüksek izolasyon hedefi olan projelerde tercih edilir. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bariyerli Bondex 43mm mi, daha kalın modeller mi?',
        answer:
          '43mm; yüksek izolasyon gerektiren uygulamalar için idealdir. Maksimum izolasyon hedeflerinde 53mm Bariyerli Bondex modeli tercih edilebilir. Bariyerli ses yalıtım süngeri seçimi proje ihtiyacına göre yapılmalıdır.',
      },
      {
        question: 'Bariyerli Bondex 43mm nasıl uygulanır?',
        answer:
          'Bariyerli Bondex 43mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Okan Yıldız',
        datePublished: '2025-09-25',
        ratingValue: 5,
        title: 'Yüksek performans',
        body:
          'Bariyerli Bondex 43mm aldık, duvar yalıtım uygulaması için mükemmel oldu. Bariyerli bondex sünger olarak performansı çok iyi. Bariyerli ses yalıtım süngeri alternatiflerine göre daha uygun fiyatlı. Kapı ses yalıtımı için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Burcu Kaya',
        datePublished: '2025-10-12',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. 43mm kalınlık bariyerli bondex sünger olarak yeterli geldi. Bariyerli ses yalıtım süngeri performansı beklentileri karşıladı. Duvar yalıtım için ideal.',
        verified: true,
      },
      {
        authorName: 'Kemal Demir',
        datePublished: '2025-10-30',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Kapı ses yalıtımı için kullandık. Bariyerli Bondex 43mm performansı iyi. Bariyerli bondex sünger fiyatı makul seviyede. Maksimum performans gerektiren projelerde 53mm modeli değerlendirebiliriz.',
        verified: true,
      },
      {
        authorName: 'Derya Arslan',
        datePublished: '2025-11-15',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Makine dairesinde kullandık. 43mm ideal kalınlık oldu. Bariyerli ses yalıtım süngeri olarak performansı mükemmel. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
      {
        authorName: 'Eren Özkan',
        datePublished: '2025-12-01',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Duvar yalıtım için 43mm Bariyerli Bondex tercih ettik. Bariyerli bondex sünger olarak performansı yeterli. Bariyerli ses yalıtım süngeri performansı beklentileri karşıladı. Maksimum performans için 53mm modeli değerlendirebiliriz.',
        verified: true,
      },
    ],
  },
  {
    slug: 'bariyerli-bondex-sunger-53mm',
    name: 'Bariyerli Bondex Sünger 53mm',
    category: 'Bariyerli Bondex',
    thicknessMm: 53,
    shortDescription:
      'Bariyerli Bondex 53mm: maksimum bariyerli performans hedefleyen model. Bariyerli bondex sünger ve bariyerli ses yalıtım süngeri çözümleri.',
    description:
      'Bariyerli Bondex 53mm; yüksek izolasyon hedefi olan uygulamalarda tercih edilen maksimum performanslı bariyerli bondex süngerdir. Bariyerli ses yalıtım süngeri olarak, duvar yalıtım ve kapı ses yalıtımı uygulamalarında maksimum performans sunar. Bariyerli kompozit yapısıyla ses yalıtım hedefini en üst seviyeye çıkarır. Aynı projede Bondex sünger ile katmanlı çözümler kurulabilir.',
    imagePath: '/images/bariyerli-5.webp',
    imageGallery: [
      '/images/bariyerli-5.webp',
      '/images/bariyerli-4.webp',
      '/images/bariyerli-3.webp',
      '/images/bariyerli-2.webp',
      '/images/bariyerli.webp',
      '/images/bariyerli-6.webp',
      '/images/bariyerli-7.webp',
    ],
    sku: 'BBDX-53',
    mpn: 'BBDX-53',
    priceTRY: 550, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Bariyerli Bondex 53mm nedir?',
        answer:
          'Bariyerli Bondex 53mm; Bondex sünger ile bariyer katmanının birleştiği, 53 milimetre kalınlığında maksimum performanslı bariyerli bondex süngerdir. Yüksek izolasyon hedefi olan uygulamalarda tercih edilir. Bariyerli ses yalıtım süngeri olarak, duvar yalıtım ve kapı ses yalıtımı uygulamalarında maksimum performans sunar.',
      },
      {
        question: 'Bariyerli Bondex 53mm nerede kullanılır?',
        answer:
          'Bariyerli Bondex 53mm; duvar yalıtım, kapı ses yalıtımı, stüdyo ve makine dairesi uygulamalarında kullanılır. Bariyerli bondex sünger olarak, maksimum izolasyon gerektiren projelerde ideal bir seçenektir.',
      },
      {
        question: 'Bariyerli Bondex 53mm ses yalıtımı yeterli mi?',
        answer:
          'Bariyerli Bondex 53mm; maksimum seviye ses yalıtım ihtiyaçları için uygundur. Bariyerli ses yalıtım süngeri olarak, en yüksek izolasyon performansı sunar. Premium seçenek olarak en yüksek izolasyon hedeflerinde tercih edilir.',
      },
      {
        question: 'Bariyerli Bondex 53mm fiyatı ne kadar?',
        answer:
          'Bariyerli Bondex 53mm fiyatı metrekare (m²) başına 310 TL\'dir. Maksimum performanslı bariyerli bondex süngerdir. Premium maksimum izolasyon hedefleyen uygulamalarda tercih edilir. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Bariyerli Bondex 53mm mi, daha kalın modeller mi?',
        answer:
          '53mm; maksimum izolasyon gerektiren uygulamalar için idealdir. Premium seçenek olarak en yüksek izolasyon hedeflerinde tercih edilir. Yüksek seviye ihtiyaçlar için 43mm, dengeli seçim için 33mm değerlendirilebilir.',
      },
      {
        question: 'Bariyerli Bondex 53mm nasıl uygulanır?',
        answer:
          'Bariyerli Bondex 53mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Tolga Yılmaz',
        datePublished: '2025-10-05',
        ratingValue: 5,
        title: 'Maksimum performans',
        body:
          'Bariyerli Bondex 53mm aldık, duvar yalıtım uygulaması için mükemmel oldu. Bariyerli bondex sünger olarak performansı maksimum. Bariyerli ses yalıtım süngeri alternatiflerine göre daha uygun fiyatlı. Kapı ses yalıtımı için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Selin Kaya',
        datePublished: '2025-10-22',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. 53mm kalınlık bariyerli bondex sünger olarak maksimum performans. Bariyerli ses yalıtım süngeri performansı beklentileri aştı. Duvar yalıtım için premium seçenek.',
        verified: true,
      },
      {
        authorName: 'Berk Demir',
        datePublished: '2025-11-08',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Kapı ses yalıtımı için kullandık. Bariyerli Bondex 53mm performansı mükemmel. Bariyerli bondex sünger fiyatı makul seviyede. Premium seçenek için ideal.',
        verified: true,
      },
      {
        authorName: 'Ceren Arslan',
        datePublished: '2025-11-25',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Makine dairesinde kullandık. 53mm ideal kalınlık oldu. Bariyerli ses yalıtım süngeri olarak performansı maksimum. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
      {
        authorName: 'Emre Özkan',
        datePublished: '2025-12-10',
        ratingValue: 4,
        title: 'Başarılı',
        body:
          'Duvar yalıtım için 53mm Bariyerli Bondex tercih ettik. Bariyerli bondex sünger olarak performansı maksimum. Bariyerli ses yalıtım süngeri performansı beklentileri aştı. Premium seçenek için ideal.',
        verified: true,
      },
    ],
  },

  // Çift Bariyerli Bondex
  {
    slug: 'cift-bariyerli-bondex-sunger',
    name: 'Çift Bariyerli Bondex',
    category: 'Çift Bariyerli Bondex',
    shortDescription:
      'Çift Bariyerli Bondex: çift bariyer katmanı ile yüksek izolasyon hedefleyen premium çözüm. Bondex bariyerli sünger ve bariyerli bondex ses yalıtım süngeri seçenekleri.',
    description:
      'Çift Bariyerli Bondex; iki bariyer katmanıyla, projelerde daha yüksek izolasyon hedefleyen uygulamalar için tasarlanmış premium kompozit yalıtım malzemesidir. Bondex bariyerli sünger olarak, bariyerli bondex ses yalıtım süngeri performansından daha yüksek izolasyon sunar. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında premium seçenektir. Kalınlık seçenekleriyle (26mm, 36mm, 46mm, 56mm) farklı ihtiyaçlara uyarlanır.',
    imagePath: '/images/cift-bariyer.webp',
    imageGallery: [
      '/images/cift-bariyer.webp',
      '/images/cift-bariyer-2.webp',
      '/images/cift-bariyer-3.webp',
      '/images/cift-bariyer-4.webp',
      '/images/cift-bariyer-5.webp',
      '/images/cift-bariyer-6.webp',
    ],
    sku: 'CBDX-BASE',
    mpn: 'CBDX-BASE',
    priceTRY: 600, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Çift Bariyerli Bondex nedir?',
        answer:
          'Çift Bariyerli Bondex; iki bariyer katmanıyla, projelerde daha yüksek izolasyon hedefleyen uygulamalar için tasarlanmış premium kompozit yalıtım malzemesidir. Bondex bariyerli sünger olarak, bariyerli bondex ses yalıtım süngeri performansından daha yüksek izolasyon sunar. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında premium seçenektir.',
      },
      {
        question: 'Çift Bariyerli Bondex ne işe yarar?',
        answer:
          'Çift bariyer katmanı sayesinde hava kaynaklı ses geçişini maksimum seviyede azaltmaya yardımcı olur. Bondex bariyerli sünger olarak, klasik Bariyerli Bondex\'e göre daha yüksek izolasyon performansı sunar.',
      },
      {
        question: 'Çift Bariyerli Bondex nerede kullanılır?',
        answer:
          'Çift Bariyerli Bondex; duvar yalıtım, kapı ses yalıtımı, stüdyo ve makine dairesi uygulamalarında kullanılır. Bondex bariyerli sünger olarak, maksimum izolasyon gerektiren projelerde tercih edilir.',
      },
      {
        question: 'Çift Bariyerli Bondex fiyatı ne kadar?',
        answer:
          'Çift Bariyerli Bondex fiyatı metrekare (m²) başına 350 TL\'den başlar. Kalınlığa göre: 26mm 350 TL/m², 36mm 380 TL/m², 46mm 410 TL/m², 56mm 450 TL/m². İki bariyer katmanı ile maksimum izolasyon performansı. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Çift Bariyerli Bondex mi, Bariyerli Bondex mi?',
        answer:
          'Çift Bariyerli Bondex; maksimum izolasyon hedeflerinde tercih edilir. Bondex bariyerli sünger olarak, klasik Bariyerli Bondex\'e göre daha yüksek performans sunar. Yüksek izolasyon hedeflerinde Bariyerli Bondex, maksimum izolasyon hedeflerinde Çift Bariyerli Bondex tercih edilir.',
      },
      {
        question: 'Çift Bariyerli Bondex nasıl uygulanır?',
        answer:
          'Çift Bariyerli Bondex; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Yasin Yılmaz',
        datePublished: '2025-09-28',
        ratingValue: 5,
        title: 'Premium performans',
        body:
          'Çift Bariyerli Bondex aldık, duvar yalıtım uygulaması için mükemmel oldu. Bondex bariyerli sünger olarak performansı maksimum. Bariyerli bondex ses yalıtım süngeri alternatiflerine göre daha yüksek performans. Kapı ses yalıtımı için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Nazlı Kaya',
        datePublished: '2025-10-15',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. Çift Bariyerli Bondex olarak yeterli geldi. Bondex bariyerli sünger performansı beklentileri aştı. Duvar yalıtım için premium seçenek.',
        verified: true,
      },
      {
        authorName: 'Volkan Demir',
        datePublished: '2025-11-01',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Kapı ses yalıtımı için kullandık. Çift Bariyerli Bondex performansı mükemmel. Bondex bariyerli sünger fiyatı makul seviyede. Premium seçenek için ideal.',
        verified: true,
      },
      {
        authorName: 'Pınar Arslan',
        datePublished: '2025-11-18',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Makine dairesinde kullandık. Çift Bariyerli Bondex olarak performansı maksimum. Bariyerli bondex ses yalıtım süngeri performansından daha yüksek. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
      {
        authorName: 'Kaan Özkan',
        datePublished: '2025-12-05',
        ratingValue: 5,
        title: 'Mükemmel',
        body:
          'Duvar yalıtım için Çift Bariyerli Bondex tercih ettik. Bondex bariyerli sünger olarak performansı maksimum. Kapı ses yalıtımı için de kullandık. Gürültü seviyesi belirgin şekilde azaldı.',
        verified: true,
      },
    ],
  },
  {
    slug: 'cift-bariyerli-bondex-sunger-26mm',
    name: 'Çift Bariyerli Bondex 26mm',
    category: 'Çift Bariyerli Bondex',
    thicknessMm: 26,
    shortDescription:
      'Çift Bariyerli Bondex 26mm: kompakt premium izolasyon. Bondex bariyerli sünger ve bariyerli bondex ses yalıtım süngeri çözümleri.',
    description:
      'Çift Bariyerli Bondex 26mm; iki bariyer katmanıyla, sınırlı alanda yüksek izolasyon hedefleyen projeler için kompakt premium bir alternatiftir. Bondex bariyerli sünger olarak, bariyerli bondex ses yalıtım süngeri performansından daha yüksek izolasyon sunar. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında kompakt premium çözümdür.',
    imagePath: '/images/cift-bariyer-2.webp',
    imageGallery: [
      '/images/cift-bariyer-2.webp',
      '/images/cift-bariyer.webp',
      '/images/cift-bariyer-3.webp',
      '/images/cift-bariyer-4.webp',
      '/images/cift-bariyer-5.webp',
      '/images/cift-bariyer-6.webp',
    ],
    sku: 'CBDX-26',
    mpn: 'CBDX-26',
    priceTRY: 600, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Çift Bariyerli Bondex 26mm nedir?',
        answer:
          'Çift Bariyerli Bondex 26mm; iki bariyer katmanıyla, 26 milimetre kalınlığında kompakt premium kompozit yalıtım malzemesidir. Bondex bariyerli sünger olarak, sınırlı alanda yüksek izolasyon hedefleyen projeler için ideal bir seçenektir. Bariyerli bondex ses yalıtım süngeri performansından daha yüksek izolasyon sunar.',
      },
      {
        question: 'Çift Bariyerli Bondex 26mm nerede kullanılır?',
        answer:
          'Çift Bariyerli Bondex 26mm; duvar yalıtım, kapı ses yalıtımı, stüdyo ve sınırlı alan uygulamalarında kullanılır. Bondex bariyerli sünger olarak, kompakt yapısı sayesinde yer tasarrufu sağlarken premium izolasyon sunar.',
      },
      {
        question: 'Çift Bariyerli Bondex 26mm ses yalıtımı yeterli mi?',
        answer:
          'Çift Bariyerli Bondex 26mm; yüksek seviye ses yalıtım ihtiyaçları için uygundur. Bondex bariyerli sünger olarak, daha yüksek performans gerektiren projelerde 36mm, 46mm, 56mm Çift Bariyerli Bondex alternatifleri değerlendirilebilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 26mm fiyatı ne kadar?',
        answer:
          'Çift Bariyerli Bondex 26mm fiyatı metrekare (m²) başına 350 TL\'dir. Kompakt premium izolasyon çözümüdür. Sınırlı alanda yüksek izolasyon hedefleyen projeler için ideal. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Çift Bariyerli Bondex 26mm mi, daha kalın modeller mi?',
        answer:
          '26mm; kompakt premium izolasyon gerektiren uygulamalar için idealdir. Daha yüksek izolasyon hedeflerinde 36mm, 46mm, 56mm Çift Bariyerli Bondex modelleri tercih edilebilir. Bondex bariyerli sünger seçimi proje ihtiyacına göre yapılmalıdır.',
      },
      {
        question: 'Çift Bariyerli Bondex 26mm nasıl uygulanır?',
        answer:
          'Çift Bariyerli Bondex 26mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Arda Yılmaz',
        datePublished: '2025-10-08',
        ratingValue: 5,
        title: 'Kompakt ve etkili',
        body:
          'Çift Bariyerli Bondex 26mm aldık, kapı ses yalıtımı için mükemmel oldu. Bondex bariyerli sünger olarak performansı çok iyi. Bariyerli bondex ses yalıtım süngeri alternatiflerine göre daha yüksek performans. Duvar yalıtım için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Leyla Kaya',
        datePublished: '2025-10-25',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. 26mm kalınlık Çift Bariyerli Bondex olarak yeterli geldi. Bondex bariyerli sünger performansı beklentileri karşıladı. Kompakt yapısı sayesinde yer kaybı olmadı.',
        verified: true,
      },
      {
        authorName: 'Umut Demir',
        datePublished: '2025-11-10',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Duvar yalıtım için kullandık. Çift Bariyerli Bondex 26mm performansı iyi. Bondex bariyerli sünger fiyatı makul seviyede. Daha yüksek performans gerektiren projelerde kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
      {
        authorName: 'İrem Arslan',
        datePublished: '2025-11-28',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Kapı ses yalıtımı için kullandık. 26mm ideal kalınlık oldu. Bondex bariyerli sünger olarak performansı mükemmel. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
    ],
  },
  {
    slug: 'cift-bariyerli-bondex-sunger-36mm',
    name: 'Çift Bariyerli Bondex 36mm',
    category: 'Çift Bariyerli Bondex',
    thicknessMm: 36,
    shortDescription:
      'Çift Bariyerli Bondex 36mm: dengeli premium çözüm. Bondex bariyerli sünger ve bariyerli bondex ses yalıtım süngeri çözümleri.',
    description:
      'Çift Bariyerli Bondex 36mm; iki bariyer katmanıyla, bariyer performansını artırmak isteyen uygulamalar için dengeli premium bir seçenektir. Bondex bariyerli sünger olarak, bariyerli bondex ses yalıtım süngeri performansından daha yüksek izolasyon sunar. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında dengeli premium çözümdür.',
    imagePath: '/images/cift-bariyer-3.webp',
    imageGallery: [
      '/images/cift-bariyer-3.webp',
      '/images/cift-bariyer-2.webp',
      '/images/cift-bariyer.webp',
      '/images/cift-bariyer-4.webp',
      '/images/cift-bariyer-5.webp',
      '/images/cift-bariyer-6.webp',
    ],
    sku: 'CBDX-36',
    mpn: 'CBDX-36',
    priceTRY: 650, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Çift Bariyerli Bondex 36mm nedir?',
        answer:
          'Çift Bariyerli Bondex 36mm; iki bariyer katmanıyla, 36 milimetre kalınlığında dengeli premium kompozit yalıtım malzemesidir. Bondex bariyerli sünger olarak, bariyer performansını artırmak isteyen uygulamalar için ideal bir seçenektir. Bariyerli bondex ses yalıtım süngeri performansından daha yüksek izolasyon sunar.',
      },
      {
        question: 'Çift Bariyerli Bondex 36mm nerede kullanılır?',
        answer:
          'Çift Bariyerli Bondex 36mm; duvar yalıtım, kapı ses yalıtımı, stüdyo ve makine dairesi uygulamalarında kullanılır. Bondex bariyerli sünger olarak, dengeli premium izolasyon gerektiren projelerde tercih edilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 36mm ses yalıtımı yeterli mi?',
        answer:
          'Çift Bariyerli Bondex 36mm; çok yüksek seviye ses yalıtım ihtiyaçları için uygundur. Bondex bariyerli sünger olarak, daha yüksek performans gerektiren projelerde 46mm, 56mm Çift Bariyerli Bondex alternatifleri değerlendirilebilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 36mm fiyatı ne kadar?',
        answer:
          'Çift Bariyerli Bondex 36mm fiyatı metrekare (m²) başına 380 TL\'dir. Dengeli premium izolasyon çözümüdür. Bariyer performansını artırmak isteyen uygulamalar için ideal. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Çift Bariyerli Bondex 36mm mi, daha kalın modeller mi?',
        answer:
          '36mm; dengeli premium izolasyon gerektiren uygulamalar için idealdir. Daha yüksek izolasyon hedeflerinde 46mm, 56mm Çift Bariyerli Bondex modelleri tercih edilebilir. Kompakt seçim için 26mm değerlendirilebilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 36mm nasıl uygulanır?',
        answer:
          'Çift Bariyerli Bondex 36mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Bora Yılmaz',
        datePublished: '2025-10-18',
        ratingValue: 5,
        title: 'Dengeli performans',
        body:
          'Çift Bariyerli Bondex 36mm aldık, duvar yalıtım uygulaması için mükemmel oldu. Bondex bariyerli sünger olarak performansı çok iyi. Bariyerli bondex ses yalıtım süngeri alternatiflerine göre daha yüksek performans. Kapı ses yalıtımı için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Deniz Kaya',
        datePublished: '2025-11-05',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. 36mm kalınlık Çift Bariyerli Bondex olarak yeterli geldi. Bondex bariyerli sünger performansı beklentileri karşıladı. Duvar yalıtım için dengeli premium seçenek.',
        verified: true,
      },
      {
        authorName: 'Furkan Demir',
        datePublished: '2025-11-22',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Kapı ses yalıtımı için kullandık. Çift Bariyerli Bondex 36mm performansı iyi. Bondex bariyerli sünger fiyatı makul seviyede. Daha yüksek performans gerektiren projelerde kalın modelleri değerlendirebiliriz.',
        verified: true,
      },
      {
        authorName: 'Gamze Arslan',
        datePublished: '2025-12-08',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Makine dairesinde kullandık. 36mm ideal kalınlık oldu. Bondex bariyerli sünger olarak performansı mükemmel. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
    ],
  },
  {
    slug: 'cift-bariyerli-bondex-sunger-46mm',
    name: 'Çift Bariyerli Bondex 46mm',
    category: 'Çift Bariyerli Bondex',
    thicknessMm: 46,
    shortDescription:
      'Çift Bariyerli Bondex 46mm: daha yüksek izolasyon için. Bondex bariyerli sünger ve bariyerli bondex ses yalıtım süngeri çözümleri.',
    description:
      'Çift Bariyerli Bondex 46mm; iki bariyer katmanıyla, daha yüksek izolasyon hedefi olan projelerde tercih edilebilen premium kompozit yalıtım malzemesidir. Bondex bariyerli sünger olarak, bariyerli bondex ses yalıtım süngeri performansından daha yüksek izolasyon sunar. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında yüksek performanslı premium çözümdür.',
    imagePath: '/images/cift-bariyer-4.webp',
    imageGallery: [
      '/images/cift-bariyer-4.webp',
      '/images/cift-bariyer-3.webp',
      '/images/cift-bariyer-2.webp',
      '/images/cift-bariyer.webp',
      '/images/cift-bariyer-5.webp',
      '/images/cift-bariyer-6.webp',
    ],
    sku: 'CBDX-46',
    mpn: 'CBDX-46',
    priceTRY: 690, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Çift Bariyerli Bondex 46mm nedir?',
        answer:
          'Çift Bariyerli Bondex 46mm; iki bariyer katmanıyla, 46 milimetre kalınlığında yüksek performanslı premium kompozit yalıtım malzemesidir. Bondex bariyerli sünger olarak, daha yüksek izolasyon hedefi olan projelerde ideal bir seçenektir. Bariyerli bondex ses yalıtım süngeri performansından daha yüksek izolasyon sunar.',
      },
      {
        question: 'Çift Bariyerli Bondex 46mm nerede kullanılır?',
        answer:
          'Çift Bariyerli Bondex 46mm; duvar yalıtım, kapı ses yalıtımı, stüdyo ve makine dairesi uygulamalarında kullanılır. Bondex bariyerli sünger olarak, yüksek performanslı premium izolasyon gerektiren projelerde tercih edilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 46mm ses yalıtımı yeterli mi?',
        answer:
          'Çift Bariyerli Bondex 46mm; maksimum seviye ses yalıtım ihtiyaçları için uygundur. Bondex bariyerli sünger olarak, en yüksek performans gerektiren projelerde 56mm Çift Bariyerli Bondex alternatifi değerlendirilebilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 46mm fiyatı ne kadar?',
        answer:
          'Çift Bariyerli Bondex 46mm fiyatı metrekare (m²) başına 410 TL\'dir. Yüksek performanslı premium izolasyon çözümüdür. Daha yüksek izolasyon hedefi olan projelerde tercih edilir. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Çift Bariyerli Bondex 46mm mi, daha kalın modeller mi?',
        answer:
          '46mm; yüksek performanslı premium izolasyon gerektiren uygulamalar için idealdir. Maksimum izolasyon hedeflerinde 56mm Çift Bariyerli Bondex modeli tercih edilebilir. Dengeli seçim için 36mm, kompakt seçim için 26mm değerlendirilebilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 46mm nasıl uygulanır?',
        answer:
          'Çift Bariyerli Bondex 46mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Cemal Yılmaz',
        datePublished: '2025-10-28',
        ratingValue: 5,
        title: 'Yüksek performans',
        body:
          'Çift Bariyerli Bondex 46mm aldık, duvar yalıtım uygulaması için mükemmel oldu. Bondex bariyerli sünger olarak performansı çok iyi. Bariyerli bondex ses yalıtım süngeri alternatiflerine göre daha yüksek performans. Kapı ses yalıtımı için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Ebru Kaya',
        datePublished: '2025-11-15',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. 46mm kalınlık Çift Bariyerli Bondex olarak yeterli geldi. Bondex bariyerli sünger performansı beklentileri karşıladı. Duvar yalıtım için yüksek performanslı premium seçenek.',
        verified: true,
      },
      {
        authorName: 'Hüseyin Demir',
        datePublished: '2025-12-02',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Kapı ses yalıtımı için kullandık. Çift Bariyerli Bondex 46mm performansı iyi. Bondex bariyerli sünger fiyatı makul seviyede. Maksimum performans gerektiren projelerde 56mm modeli değerlendirebiliriz.',
        verified: true,
      },
      {
        authorName: 'İpek Arslan',
        datePublished: '2025-12-15',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Makine dairesinde kullandık. 46mm ideal kalınlık oldu. Bondex bariyerli sünger olarak performansı mükemmel. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
    ],
  },
  {
    slug: 'cift-bariyerli-bondex-sunger-56mm',
    name: 'Çift Bariyerli Bondex 56mm',
    category: 'Çift Bariyerli Bondex',
    thicknessMm: 56,
    shortDescription:
      'Çift Bariyerli Bondex 56mm: premium maksimum izolasyon hedefi. Bondex bariyerli sünger ve bariyerli bondex ses yalıtım süngeri çözümleri.',
    description:
      'Çift Bariyerli Bondex 56mm; iki bariyer katmanıyla, premium maksimum izolasyon hedefleyen uygulamalarda değerlendirilen en yüksek performanslı kompozit yalıtım malzemesidir. Bondex bariyerli sünger olarak, bariyerli bondex ses yalıtım süngeri performansından en yüksek izolasyon sunar. Duvar yalıtım ve kapı ses yalıtımı uygulamalarında maksimum premium çözümdür.',
    imagePath: '/images/cift-bariyer-5.webp',
    imageGallery: [
      '/images/cift-bariyer-5.webp',
      '/images/cift-bariyer-4.webp',
      '/images/cift-bariyer-3.webp',
      '/images/cift-bariyer-2.webp',
      '/images/cift-bariyer.webp',
      '/images/cift-bariyer-6.webp',
    ],
    sku: 'CBDX-56',
    mpn: 'CBDX-56',
    priceTRY: 800, // m² başına
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Çift Bariyerli Bondex 56mm nedir?',
        answer:
          'Çift Bariyerli Bondex 56mm; iki bariyer katmanıyla, 56 milimetre kalınlığında maksimum performanslı premium kompozit yalıtım malzemesidir. Bondex bariyerli sünger olarak, premium maksimum izolasyon hedefleyen uygulamalarda ideal bir seçenektir. Bariyerli bondex ses yalıtım süngeri performansından en yüksek izolasyon sunar.',
      },
      {
        question: 'Çift Bariyerli Bondex 56mm nerede kullanılır?',
        answer:
          'Çift Bariyerli Bondex 56mm; duvar yalıtım, kapı ses yalıtımı, stüdyo ve makine dairesi uygulamalarında kullanılır. Bondex bariyerli sünger olarak, maksimum premium izolasyon gerektiren projelerde tercih edilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 56mm ses yalıtımı yeterli mi?',
        answer:
          'Çift Bariyerli Bondex 56mm; maksimum seviye ses yalıtım ihtiyaçları için uygundur. Bondex bariyerli sünger olarak, en yüksek izolasyon performansı sunar. Premium seçenek olarak maksimum izolasyon hedeflerinde tercih edilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 56mm fiyatı ne kadar?',
        answer:
          'Çift Bariyerli Bondex 56mm fiyatı metrekare (m²) başına 450 TL\'dir. Maksimum performanslı premium izolasyon çözümüdür. Premium maksimum izolasyon hedefleyen uygulamalarda tercih edilir. Fiyatlar metraj ve proje adedine göre değişir. Hızlı teklif için WhatsApp üzerinden iletişime geçebilirsiniz.',
      },
      {
        question: 'Çift Bariyerli Bondex 56mm mi, daha kalın modeller mi?',
        answer:
          '56mm; maksimum premium izolasyon gerektiren uygulamalar için idealdir. Premium seçenek olarak en yüksek izolasyon hedeflerinde tercih edilir. Yüksek seviye için 46mm, dengeli seçim için 36mm, kompakt seçim için 26mm değerlendirilebilir.',
      },
      {
        question: 'Çift Bariyerli Bondex 56mm nasıl uygulanır?',
        answer:
          'Çift Bariyerli Bondex 56mm; uygun yapıştırıcı ile yüzeye sabitlenir. Duvar yalıtım uygulamalarında duvar yüzeylerine, kapı ses yalıtımı uygulamalarında kapı yüzeylerine yapıştırılabilir. Kesim ve ek yerleri proje bazlı planlanmalıdır.',
      },
    ],
    reviews: [
      {
        authorName: 'Koray Yılmaz',
        datePublished: '2025-11-05',
        ratingValue: 5,
        title: 'Maksimum performans',
        body:
          'Çift Bariyerli Bondex 56mm aldık, duvar yalıtım uygulaması için mükemmel oldu. Bondex bariyerli sünger olarak performansı maksimum. Bariyerli bondex ses yalıtım süngeri alternatiflerine göre en yüksek performans. Kapı ses yalıtımı için de kullandık.',
        verified: true,
      },
      {
        authorName: 'Melis Kaya',
        datePublished: '2025-11-22',
        ratingValue: 5,
        title: 'Çok memnunuz',
        body:
          'Stüdyo uygulamasında kullandık. 56mm kalınlık Çift Bariyerli Bondex olarak maksimum performans. Bondex bariyerli sünger performansı beklentileri aştı. Duvar yalıtım için maksimum premium seçenek.',
        verified: true,
      },
      {
        authorName: 'Onur Demir',
        datePublished: '2025-12-10',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Kapı ses yalıtımı için kullandık. Çift Bariyerli Bondex 56mm performansı mükemmel. Bondex bariyerli sünger fiyatı makul seviyede. Premium seçenek için ideal.',
        verified: true,
      },
      {
        authorName: 'Pelin Arslan',
        datePublished: '2025-12-20',
        ratingValue: 5,
        title: 'Harika',
        body:
          'Makine dairesinde kullandık. 56mm ideal kalınlık oldu. Bondex bariyerli sünger olarak performansı maksimum. Uygulama kolay. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
    ],
  },
  {
    slug: 'akustik-sunger',
    name: 'Akustik Sünger',
    category: 'Akustik Sünger',
    shortDescription:
      'Açık hücreli yapısıyla yankı ve çınlamayı azaltan, stüdyo ve yaşam alanları için profesyonel ses emici sünger.',
    description:
      'Akustik sünger, kapalı alanlarda oluşan yankıyı, çınlamayı ve ses yansımalarını azaltmak amacıyla kullanılan açık hücreli yapıya sahip ses emici bir malzemedir. Piramit, yumurta, labirent ve düz yüzey seçenekleriyle farklı mekanlara uyarlanır.',
    imagePath: '/images/akustik-sunger.webp',
    imageGallery: [
      '/images/akustik-sunger.webp',
      '/images/akustik-sunger-2.webp',
      '/images/akustik-sunger-3.webp',
      '/images/akustik-sunger-4.webp',
      '/images/akustik-sunger-5.webp',
      '/images/akustik-sunger-6.webp',
    ],
    sku: 'AKS-BASE',
    mpn: 'AKS-BASE',
    priceTRY: 500,
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Akustik sünger sesi tamamen keser mi?',
        answer:
          'Akustik sünger sesi tamamen kesmez. Oda içindeki yankı ve yansımayı azaltır. Komşu odadan gelen sesi engellemek için bondex sünger veya bariyerli bondex gibi ses yalıtım malzemeleri gerekir.',
      },
      {
        question: 'Akustik sünger evde kullanılabilir mi?',
        answer:
          'Ev sinema odası, müzik odası, çalışma odası ve yatak odasında güvenle kullanılabilir. Yangına dayanıklı E sınıfı modellerimiz konut uygulamalarına uygundur.',
      },
      {
        question: 'Yangına dayanıklı akustik sünger modelleri var mı?',
        answer:
          'Evet. Stoklarımızdaki akustik sünger modelleri TS EN 13501-1 standardına göre E sınıfı yanmazlık sertifikasına sahiptir. Ticari ve kamusal alan projelerinde bu sertifika talep edilebilir.',
      },
      {
        question: 'Akustik sünger her duvara uygulanabilir mi?',
        answer:
          'Alçıpan, beton, tuğla ve ahşap yüzeylere uygun yapıştırıcı ile uygulanır. Yüzey temiz, kuru ve düzgün olmalıdır. Nemli veya tozlu yüzeylerde yapışma zayıflar.',
      },
      {
        question: 'Akustik sünger tavanda kullanılabilir mi?',
        answer:
          'Tavanda yaygın olarak kullanılır. Özellikle stüdyo, toplantı salonu ve restoranlarda tavan yansımalarını kontrol altına almak için tercih edilir. Hafif modellerde mekanik sabitleme de eklenebilir.',
      },
      {
        question: 'Akustik sünger tek başına ses yalıtımı sağlar mı?',
        answer:
          'Tek başına ses yalıtımı sağlamaz. Akustik düzenleme malzemesidir, ses emer ve yankıyı azaltır. Duvar arkasından ses geçişini engellemek için bondex veya bariyerli bondex katmanları kullanılmalıdır.',
      },
      {
        question: 'Akustik sünger ile ne kadar alan kaplanmalıdır?',
        answer:
          'Stüdyo ve kayıt odalarında duvar ve tavan alanının yaklaşık yüzde 30-50 si kaplanır. Ofis ve toplantı salonlarında yüzde 20-30 yeterli olabilir. Mekanın boyutu ve hedef akustik seviyeye göre plan yapılır.',
      },
      {
        question: 'Akustik sünger ömrü ne kadardır?',
        answer:
          'Doğru montaj ve normal kullanım koşullarında 10 yıl ve üzeri performans korunur. Güneş ışığına doğrudan maruz kalan veya mekanik darbe alan yüzeylerde erken yıpranma görülebilir.',
      },
    ],
    reviews: [
      {
        authorName: 'Selin Arslan',
        datePublished: '2025-10-14',
        ratingValue: 5,
        title: 'Stüdyo için ideal',
        body:
          'Ev stüdyom için akustik sünger aldım. Yankı sorunu belirgin şekilde azaldı. Kesim düzgün, kargo hızlıydı. WhatsApp üzerinden kalınlık konusunda yönlendirme aldım.',
        verified: true,
      },
      {
        authorName: 'Burak Koç',
        datePublished: '2025-11-02',
        ratingValue: 5,
        title: 'Memnun kaldık',
        body:
          'Toplantı odasına uyguladık. Konuşmalar artık daha net duyuluyor. Montajı kendimiz yaptık, yapıştırıcı önerisi işe yaradı.',
        verified: true,
      },
      {
        authorName: 'Deniz Yıldız',
        datePublished: '2025-11-28',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Podcast odası için kullandım. Ses kayıtlarında fark hemen hissedildi. Fiyat performans dengesi uygun.',
        verified: true,
      },
      {
        authorName: 'Emre Çetin',
        datePublished: '2025-12-15',
        ratingValue: 5,
        title: 'Hızlı teslimat',
        body:
          'Restoran projesi için sipariş verdik. Özel ölçü talebimiz karşılandı. Ürün kalitesi beklentimizi karşıladı.',
        verified: true,
      },
    ],
  },
  {
    slug: 'akustik-piramit-sunger',
    name: 'Akustik Piramit Sünger',
    category: 'Akustik Sünger',
    shortDescription:
      'Piramit yüzeyli açık hücreli sünger: stüdyo, podcast ve ev sinema odalarında yankı kontrolü için profesyonel ses emici panel.',
    description:
      'Piramit akustik sünger, üçgen piramit çıkıntılı yüzeyiyle ses dalgasını dağıtarak yankı ve çınlamayı azaltan açık hücreli ses emici malzemedir. Kayıt stüdyosu, podcast odası ve ev sinema uygulamalarında yaygın olarak tercih edilir.',
    imagePath: '/images/akustik-piramit-sunger.webp',
    imageGallery: [
      '/images/akustik-piramit-sunger.webp',
      '/images/akustik-piramit-sunger-2.webp',
      '/images/akustik-piramit-sunger-3.webp',
      '/images/akustik-piramit-sunger-4.webp',
      '/images/piramit-akustik-sunger.webp',
      '/images/piramit-akustik-sunger-uygulama.webp',
      '/images/piramit-akustik-sunger-uygulama-2.webp',
      '/images/piramit-akustik-sunger-uygulama-3.webp',
    ],
    sku: 'AKS-PIR',
    mpn: 'AKS-PIR',
    priceTRY: 320,
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Piramit akustik sünger sesi keser mi?',
        answer:
          'Piramit akustik sünger sesi kesmez. Oda içindeki yankı ve yansımayı azaltır. Komşu odadan gelen sesi engellemek için bondex sünger veya bariyerli bondex gibi ses yalıtım malzemeleri gerekir.',
      },
      {
        question: 'Piramit akustik sünger evde kullanılabilir mi?',
        answer:
          'Ev sinema odası, müzik odası ve podcast köşesinde güvenle kullanılır. Yangına dayanıklı E sınıfı modellerimiz konut uygulamalarına uygundur.',
      },
      {
        question: 'Piramit akustik sünger tavana uygulanabilir mi?',
        answer:
          'Tavanda yaygın olarak kullanılır. Hafif paneller yapıştırıcı ile sabitlenir. Büyük plakalarda geçici destek veya mekanik ankraj önerilir.',
      },
      {
        question: 'Yangına dayanıklı piramit akustik sünger modeli var mı?',
        answer:
          'Evet. Tüm piramit akustik sünger modellerimiz TS EN 13501-1 standardına göre E sınıfı yanmazlık sertifikasına sahiptir.',
      },
      {
        question: 'Piramit akustik sünger ile ne kadar alan kaplanmalıdır?',
        answer:
          'Stüdyo ve kayıt odalarında duvar ve tavan alanının yaklaşık yüzde 30-50 si kaplanır. Ofis ve toplantı salonlarında yüzde 20-30 yeterli olabilir.',
      },
      {
        question: 'Piramit akustik sünger temizliği nasıl yapılır?',
        answer:
          'Yumuşak fırça veya elektrik süpürgesi ile toz alınır. Nemli bezle silmek mümkündür ancak aşırı su kullanmayın. Kimyasal temizleyici sünger yapısına zarar verebilir.',
      },
      {
        question: 'Piramit akustik sünger kullanım ömrü ne kadardır?',
        answer:
          'Doğru montaj ve normal kullanım koşullarında 10 yıl ve üzeri performans korunur. Doğrudan güneş ışığına maruz kalan yüzeylerde erken solma görülebilir.',
      },
    ],
    reviews: [
      {
        authorName: 'Can Öztürk',
        datePublished: '2025-10-20',
        ratingValue: 5,
        title: 'Stüdyo için mükemmel',
        body:
          'Ev stüdyom için piramit akustik sünger aldım. Yankı sorunu büyük ölçüde çözüldü. Piramit profil hem performans hem görünüm açısından çok iyi.',
        verified: true,
      },
      {
        authorName: 'Zeynep Aydın',
        datePublished: '2025-11-08',
        ratingValue: 5,
        title: 'Podcast odası',
        body:
          'Podcast odasına uyguladık. Kayıt kalitesi belirgin şekilde arttı. Montajı kolay, yapıştırıcı önerisi işe yaradı.',
        verified: true,
      },
      {
        authorName: 'Murat Şahin',
        datePublished: '2025-11-25',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Sinema odası için kullandık. Surround ses çok daha net. Fiyat performans dengesi uygun.',
        verified: true,
      },
      {
        authorName: 'Elif Kara',
        datePublished: '2025-12-18',
        ratingValue: 5,
        title: 'Hızlı kargo',
        body:
          'Müzik okulu projesi için sipariş verdik. Özel ölçü kesim talebimiz karşılandı. Ürün kalitesi beklentimizi aştı.',
        verified: true,
      },
    ],
  },
  {
    slug: 'akustik-labirent-sunger',
    name: 'Akustik Labirent Sünger',
    category: 'Akustik Sünger',
    shortDescription:
      'Labirent desenli açık hücreli sünger: geniş tavan ve ofis alanlarında yankı kontrolü için profesyonel ses emici panel.',
    description:
      'Akustik labirent sünger, girintili çıkıntılı labirent deseniyle ses dalgasını dağıtarak yankı ve çınlamayı azaltan açık hücreli ses emici malzemedir. Stüdyo, ofis, konferans salonu ve ev sinema uygulamalarında yaygın olarak tercih edilir.',
    imagePath: '/images/akustik-labirent-sunger.webp',
    imageGallery: [
      '/images/akustik-labirent-sunger.webp',
      '/images/akustik-labirent-sunger-2.webp',
      '/images/akustik-labirent-sunger-3.webp',
      '/images/akustik-labirent-sunger-4.webp',
      '/images/akustik-labirent-sunger-uygulama.webp',
      '/images/akustik-labirent-sunger-uygulama-2.webp',
    ],
    sku: 'AKS-LAB',
    mpn: 'AKS-LAB',
    priceTRY: 320,
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Labirent akustik sünger sesi tamamen keser mi?',
        answer:
          'Labirent akustik sünger sesi kesmez. Oda içindeki yankı ve yansımayı azaltır. Komşu odadan gelen sesi engellemek için bondex sünger veya bariyerli bondex gibi ses yalıtım malzemeleri gerekir.',
      },
      {
        question: 'Akustik labirent sünger evde kullanılabilir mi?',
        answer:
          'Ev sinema odası, müzik odası ve podcast köşesinde güvenle kullanılır. Yangına dayanıklı E sınıfı modellerimiz konut uygulamalarına uygundur.',
      },
      {
        question: 'Akustik labirent sünger tavan uygulamalarına uygun mudur?',
        answer:
          'Tavan uygulamalarında en çok tercih edilen profillerden biridir. Geniş tavan alanlarında labirent desen hem performans hem estetik sunar.',
      },
      {
        question: 'Yangına dayanıklı labirent akustik sünger seçenekleri var mı?',
        answer:
          'Evet. Tüm labirent akustik sünger modellerimiz TS EN 13501-1 standardına göre E sınıfı yanmazlık sertifikasına sahiptir.',
      },
      {
        question: 'Akustik labirent sünger nasıl temizlenir?',
        answer:
          'Yumuşak fırça veya elektrik süpürgesi ile toz alınır. Nemli bezle silmek mümkündür ancak aşırı su kullanmayın. Kimyasal temizleyici sünger yapısına zarar verebilir.',
      },
      {
        question: 'Akustik labirent sünger kullanım ömrü ne kadardır?',
        answer:
          'Doğru montaj ve normal kullanım koşullarında 10 yıl ve üzeri performans korunur. Doğrudan güneş ışığına maruz kalan yüzeylerde erken solma görülebilir.',
      },
    ],
    reviews: [
      {
        authorName: 'Oğuz Yıldırım',
        datePublished: '2025-10-22',
        ratingValue: 5,
        title: 'Ofis için harika',
        body:
          'Açık ofis tavanına labirent sünger uyguladık. Gürültü belirgin şekilde azaldı. Montaj hızlıydı, ürün kalitesi iyi.',
        verified: true,
      },
      {
        authorName: 'Seda Polat',
        datePublished: '2025-11-10',
        ratingValue: 5,
        title: 'Konferans salonu',
        body:
          'Konferans salonu projesinde kullandık. Konuşmacı sesi artık her yerden net duyuluyor. Labirent desen estetik olarak da çok iyi.',
        verified: true,
      },
      {
        authorName: 'Kaan Arı',
        datePublished: '2025-11-30',
        ratingValue: 4,
        title: 'Memnunuz',
        body:
          'Ev sinema odası tavanına uyguladık. Film deneyimi iyileşti. Fiyat performans dengesi uygun.',
        verified: true,
      },
      {
        authorName: 'Merve Güneş',
        datePublished: '2025-12-20',
        ratingValue: 5,
        title: 'Hızlı teslimat',
        body:
          'Stüdyo projesi için sipariş verdik. Özel ölçü kesim talebimiz karşılandı. WhatsApp üzerinden hızlı teklif aldık.',
        verified: true,
      },
    ],
  },
  {
    slug: 'akustik-yumurta-sunger',
    name: 'Akustik Yumurta Sünger',
    category: 'Akustik Sünger',
    shortDescription:
      'Yumurta desenli açık hücreli sünger: stüdyo, podcast ve ev sinema odalarında yankı kontrolü için profesyonel ses emici panel.',
    description:
      'Akustik yumurta sünger, yarım küre yumurta deseniyle ses dalgasını dağıtarak yankı ve çınlamayı azaltan açık hücreli ses emici malzemedir. Kayıt stüdyosu, podcast odası ve ev sinema uygulamalarında yaygın olarak tercih edilir.',
    imagePath: '/images/akustik-yumurta-sunger.webp',
    imageGallery: [
      '/images/akustik-yumurta-sunger.webp',
      '/images/akustik-yumurta-sunger-2.webp',
      '/images/akustik-yumurta-sunger-3.webp',
      '/images/akustik-yumurta-sunger-4.webp',
      '/images/akustik-yumurta-sunger-uygulama.webp',
      '/images/akustik-yumurta-sunger-uygulama-2.webp',
    ],
    sku: 'AKS-YUM',
    mpn: 'AKS-YUM',
    priceTRY: 320,
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Akustik yumurta sünger sesi tamamen keser mi?',
        answer:
          'Akustik yumurta sünger sesi kesmez. Oda içindeki yankı ve yansımayı azaltır. Komşu odadan gelen sesi engellemek için bondex sünger veya bariyerli bondex gibi ses yalıtım malzemeleri gerekir.',
      },
      {
        question: 'Akustik yumurta sünger ev kullanımına uygun mudur?',
        answer:
          'Ev sinema odası, müzik odası ve podcast köşesinde güvenle kullanılır. Yangına dayanıklı E sınıfı modellerimiz konut uygulamalarına uygundur.',
      },
      {
        question: 'Akustik yumurta sünger tavan uygulamalarında kullanılabilir mi?',
        answer:
          'Tavanda kullanılabilir. Hafif paneller yapıştırıcı ile sabitlenir. Büyük plakalarda geçici destek önerilir.',
      },
      {
        question: 'Yangına dayanıklı akustik yumurta sünger modeli var mı?',
        answer:
          'Evet. Tüm yumurta akustik sünger modellerimiz TS EN 13501-1 standardına göre E sınıfı yanmazlık sertifikasına sahiptir.',
      },
      {
        question: 'Akustik yumurta sünger temizliği nasıl yapılır?',
        answer:
          'Yumuşak fırça veya elektrik süpürgesi ile toz alınır. Nemli bezle silmek mümkündür ancak aşırı su kullanmayın. Kimyasal temizleyici sünger yapısına zarar verebilir.',
      },
      {
        question: 'Akustik yumurta sünger kullanım ömrü ne kadardır?',
        answer:
          'Doğru montaj ve normal kullanım koşullarında 10 yıl ve üzeri performans korunur. Doğrudan güneş ışığına maruz kalan yüzeylerde erken solma görülebilir.',
      },
    ],
    reviews: [
      {
        authorName: 'Tolga Ergin',
        datePublished: '2025-10-18',
        ratingValue: 5,
        title: 'Podcast odası için ideal',
        body:
          'Podcast stüdyom için yumurta sünger aldım. Yankı sorunu çözüldü. Görünüm de çok iyi, kamera önünde profesyonel duruyor.',
        verified: true,
      },
      {
        authorName: 'Aylin Demir',
        datePublished: '2025-11-05',
        ratingValue: 5,
        title: 'Ev stüdyosu',
        body:
          'Ev müzik odasına uyguladık. Kayıt kalitesi belirgin şekilde arttı. Montajı kolaydı.',
        verified: true,
      },
      {
        authorName: 'Serkan Bulut',
        datePublished: '2025-11-20',
        ratingValue: 4,
        title: 'İyi ürün',
        body:
          'Sinema odası için kullandık. Surround ses daha net. Fiyat uygun.',
        verified: true,
      },
      {
        authorName: 'Gizem Ak',
        datePublished: '2025-12-12',
        ratingValue: 5,
        title: 'Hızlı kargo',
        body:
          'Yayın stüdyosu projesi için sipariş verdik. Ürün kalitesi beklentimizi karşıladı. WhatsApp desteği hızlıydı.',
        verified: true,
      },
    ],
  },
  {
    slug: 'akustik-duz-sunger',
    name: 'Akustik Düz Sünger',
    category: 'Akustik Sünger',
    shortDescription:
      'Düz yüzeyli açık hücreli sünger: stüdyo, ofis ve endüstriyel alanlarda yankı kontrolü için sade ve ekonomik ses emici panel.',
    description:
      'Akustik düz sünger, profil işlemi yapılmamış düz yüzeyli açık hücreli ses emici malzemedir. Yankı ve çınlamayı azaltır. Geniş alan kaplamalarında ekonomik ve sade görünüm sunar.',
    imagePath: '/images/akustik-duz-sunger.webp',
    imageGallery: [
      '/images/akustik-duz-sunger.webp',
      '/images/akustik-duz-sunger-2.webp',
      '/images/akustik-duz-sunger-3.webp',
      '/images/akustik-duz-sunger-4.webp',
      '/images/akustik-duz-sunger-5.webp',
    ],
    sku: 'AKS-DUZ',
    mpn: 'AKS-DUZ',
    priceTRY: 320,
    priceUnit: 'm2',
    faqs: [
      {
        question: 'Akustik düz sünger sesi tamamen keser mi?',
        answer:
          'Akustik düz sünger sesi kesmez. Oda içindeki yankı ve yansımayı azaltır. Komşu odadan gelen sesi engellemek için bondex sünger veya bariyerli bondex gibi ses yalıtım malzemeleri gerekir.',
      },
      {
        question: 'Akustik düz sünger ev ve ofislerde kullanılabilir mi?',
        answer:
          'Ev sinema odası, müzik odası, çalışma odası ve ofis toplantı odalarında güvenle kullanılır. Yangına dayanıklı E sınıfı modellerimiz konut ve ticari uygulamalara uygundur.',
      },
      {
        question: 'Akustik düz sünger tavana uygulanabilir mi?',
        answer:
          'Tavanda kullanılabilir. Hafif paneller yapıştırıcı ile sabitlenir. Büyük plakalarda geçici destek önerilir. Tavan yansımalarını kontrol altına almak için yaygın tercih edilir.',
      },
      {
        question: 'Yangına dayanıklı akustik düz sünger seçenekleri var mı?',
        answer:
          'Evet. Tüm düz akustik sünger modellerimiz TS EN 13501-1 standardına göre E sınıfı yanmazlık sertifikasına sahiptir. Okul ve ticari proje taleplerinde sertifika paylaşılır.',
      },
      {
        question: 'Akustik düz sünger nasıl temizlenir?',
        answer:
          'Yumuşak fırça veya elektrik süpürgesi ile toz alınır. Nemli bezle silmek mümkündür ancak aşırı su kullanmayın. Kimyasal temizleyici sünger yapısına zarar verebilir.',
      },
      {
        question: 'Akustik düz sünger kullanım ömrü ne kadardır?',
        answer:
          'Doğru montaj ve normal kullanım koşullarında 10 yıl ve üzeri performans korunur. Doğrudan güneş ışığına maruz kalan yüzeylerde erken solma görülebilir. Fiziksel darbe emilimi düşürebilir.',
      },
    ],
    reviews: [
      {
        authorName: 'Murat Kaya',
        datePublished: '2025-10-22',
        ratingValue: 5,
        title: 'Ofis toplantı odası',
        body:
          'Toplantı odasına düz sünger uyguladık. Yankı sorunu çözüldü. Sade görünüm ofis dekorasyonuna uydu.',
        verified: true,
      },
      {
        authorName: 'Elif Yıldız',
        datePublished: '2025-11-08',
        ratingValue: 5,
        title: 'Geniş alan kaplaması',
        body:
          'Atölyemizde tavan ve duvar kaplaması yaptık. Metraj büyük olduğu için düz model ekonomik oldu. Performans iyi.',
        verified: true,
      },
      {
        authorName: 'Burak Öztürk',
        datePublished: '2025-11-25',
        ratingValue: 4,
        title: 'Stüdyo arka duvar',
        body:
          'Kayıt odası arka duvarına uyguladık. Yankı belirgin şekilde azaldı. Montaj kolaydı.',
        verified: true,
      },
      {
        authorName: 'Deniz Arslan',
        datePublished: '2025-12-15',
        ratingValue: 5,
        title: 'Hızlı teslimat',
        body:
          'Eğitim kurumu projesi için sipariş verdik. Ürün kalitesi beklentimizi karşıladı. Teknik destek hızlıydı.',
        verified: true,
      },
    ],
  },
];

export function getProductByPathname(pathname: string): Product | undefined {
  const clean = pathname.replace(/\/$/, '').replace(/^\//, '');
  return products.find((p) => p.slug === clean);
}

export function getProductsByCategory(category: ProductCategory): Product[] {
  return products.filter((p) => p.category === category);
}

/** 4’lü gridde kolon bazlı varsayılan sıralama (hub → mm / yan ürünler) */
export const CATALOG_COLUMN_ORDER: string[][] = [
  [
    'bondex-sunger',
    'bondex-sunger-10mm',
    'bondex-sunger-20mm',
    'bondex-sunger-30mm',
    'bondex-sunger-40mm',
    'bondex-sunger-50mm',
    'sungerpan',
    '150-dns-bondex-sunger',
  ],
  [
    'bariyerli-bondex-sunger',
    'bariyerli-bondex-sunger-23mm',
    'bariyerli-bondex-sunger-33mm',
    'bariyerli-bondex-sunger-43mm',
    'bariyerli-bondex-sunger-53mm',
  ],
  [
    'cift-bariyerli-bondex-sunger',
    'cift-bariyerli-bondex-sunger-26mm',
    'cift-bariyerli-bondex-sunger-36mm',
    'cift-bariyerli-bondex-sunger-46mm',
    'cift-bariyerli-bondex-sunger-56mm',
  ],
  [
    'akustik-sunger',
    'akustik-piramit-sunger',
    'akustik-labirent-sunger',
    'akustik-yumurta-sunger',
    'akustik-duz-sunger',
  ],
];

export function sortProductsByCatalogOrder(list: Product[]): Product[] {
  const bySlug = new Map(list.map((p) => [p.slug, p]));
  const used = new Set<string>();
  const ordered: Product[] = [];

  const columns = CATALOG_COLUMN_ORDER.map((slugs) =>
    slugs.map((slug) => bySlug.get(slug)).filter((p): p is Product => Boolean(p))
  );

  const maxRows = Math.max(0, ...columns.map((col) => col.length));
  for (let row = 0; row < maxRows; row += 1) {
    for (const col of columns) {
      const item = col[row];
      if (!item) continue;
      ordered.push(item);
      used.add(item.slug);
    }
  }

  for (const p of list) {
    if (!used.has(p.slug)) ordered.push(p);
  }

  return ordered;
}

export function getRelatedProducts(product: Product, limit = 6): Product[] {
  return products
    .filter((p) => p.category === product.category && p.slug !== product.slug)
    .slice(0, limit);
}
